import React, { useState, useRef, useEffect } from "react";
import Tooltip from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { confirmAlert } from "react-confirm-alert";
import SlidingPane from "react-sliding-pane";
import ContentLoader from "react-content-loader";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Form from "react-validation/build/form";
import { useForm } from "react-hook-form";
import CheckButton from "react-validation/build/button";
import { ToastContainer, toast } from "react-toastify";
import CurrencyInput from "react-currency-input-field";
import AsyncSelect from "react-select/async";
import axios from "axios";

import { API } from "../../../../backend";
import authHeader from "../../../../services/auth-header";
import EditAssetService from "../../../../services/contract/asset/editAssetService";
import { getTrans as t } from "../../../../Localization/translations";
import Helper from "../../../../Helper";
import ButtonLoading from "../../../../components/Loder/buttonLoading";
import AssetList from "../../../../components/assetList";
import GetCompanyInfoService from "../../../../services/company/getCompanyInfoService";
import AddPartyService from "../../../../services/party/addparty.service";
import AddPartyAddressService from "../../../../services/party/address/addAddress.service";
import SearchableDropdown from "../../../../components/DropDown/searchable";
import AddItemmasterService from "../../../../services/itemmaster/itemmasterAddService";
import EditItemMasterService from "../../../../services/itemmaster/itemmasterEditServices";
import DocumentUpload from "../../../../services/document/documentupload";
import AddcategoryService from "../../../../services/category/categoryAddServices";
import MaterialTable from "material-table";

function EditAssets({ asset_id, contractId, contract_term, party_id }) {
  const [state1, setState] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });
  const [asset_number, setAsset_number] = useState(null);
  const [asset_desc, setAsset_desc] = useState(null);
  const [license_number, setLicense_number] = useState(null);
  const [financed_amount, setFinanced_amount] = useState(null);
  const [year, setYear] = useState(null);
  const [vin_number, setVin_number] = useState(null);
  const [license_state, setLicense_state] = useState(null);
  const [dealer_payable, setDealer_payable] = useState(null);
  const [manufacturer, setManufacturer] = useState(null);
  const [make, setMake] = useState(null);
  const [model, setModel] = useState(null);
  const [user_purpose, setUser_purpose] = useState(null);
  const [residal_value, seTresidal_value] = useState(0);
  const [reg_address, setReg_address] = useState("");
  const [reg_address1, setReg_address1] = useState([]);
  const [vendorname, setVendorName] = useState([]);
  const [vendor_name, setVendor_name] = useState("");
  const [asset_type, setAssetType] = useState("");
  const [category_list, setCategory_list] = useState([]);
  const [sub_categories, setSub_categories] = useState([]);
  const [selected_category, setSelected_category] = useState("");
  const [selected_sub_category, setSelected_sub_category] = useState("");
  const [delivery_date, setDelivery_date] = useState(null);
  const [in_service_date, setIn_service_date] = useState(null);
  const [milage, setMilage] = useState(0);
  const [vehicle_cost, setVehicle_cost] = useState(0);
  const [vehicle_cost_payto, setVehicle_cost_payto] = useState(null);
  const [tax_amount, setTax_amount] = useState(0);
  const [tax_amount_payto, setTax_amount_payto] = useState(null);
  const [trade_in, setTrade_in] = useState(0);
  const [trade_in_payto, setTrade_in_payto] = useState(null);
  const [reg_cost, setReg_cost] = useState(0);
  const [reg_cost_payto, setReg_cost_payto] = useState(null);
  const [total_cost, setTotal_cost] = useState(null);
  const [down_payment, setDown_payment] = useState(0);
  const [down_payment_payto, setDown_payment_payto] = useState(null);
  const [loading, setLoading] = useState(false);
  const [hideshowedit, setHideShowEdit] = useState(false);
  const [successful, setSuccessful] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const form = useRef();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const checkBtn = useRef();
  const form2 = useRef();
  const {
    register: register2,
    handleSubmit: handleSubmit2,
    reset: reset2,
    formState: { errors: errors2 },
  } = useForm();
  const checkBtn2 = useRef();
  const form3 = useRef();
  const {
    register: register3,
    handleSubmit: handleSubmit3,
    reset: reset3,
    formState: { errors: errors3 },
  } = useForm();
  const checkBtn3 = useRef();
  const [item, setItems] = useState([]);
  const [options, setOptions] = useState([]);
  const [state3, setState3] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });
  const [attribute, setAttribute] = useState([
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
  ]);
  const [extrafiledcontractasset, setExtraFiled] = useState([]);

  //party screen
  const [party_type, setParty_type] = useState("Vendor");
  const [customer_type, setCustomer_type] = useState("Organization");
  const [showhide, setShowHide] = useState("");
  const [customer_name, setCustomer_name] = useState("");
  const [establishment_date, setEstablishment] = useState(null);
  const [date_of_birth, setDate_of_birth] = useState(null);
  const [disable, setDisable] = useState(false);

  // Address Screen
  const [address_line_1, setAddress_line_1] = useState("");
  const [address_line_2, setAddress_line_2] = useState("");
  const [city, setCity] = useState("");
  const [stateaddress, setStateAddress] = useState("");
  const [zip_code, setZip_code] = useState("");
  const [country, setCountry] = useState("");
  const [bill_to, setBill_to] = useState("Yes");
  const [ship_to, setShip_to] = useState("No");
  const [install_to, setInstall_to] = useState("Yes");

  const [installaddress_line_1, setInstallAddress_line_1] = useState("");
  const [installaddress_line_2, setInstallAddress_line_2] = useState("");
  const [installcity, setInstallCity] = useState("");
  const [installstateaddress, setInstallStateAddress] = useState("");
  const [installzip_code, setInstallZip_code] = useState("");
  const [installcountry, setInstallCountry] = useState("");
  const [installbill_to, setInstallBill_to] = useState("Yes");
  const [installship_to, setInstallShip_to] = useState("No");
  const [installinstall_to, setInstallInstall_to] = useState("Yes");

  const [vindecode, setVinDecode] = useState([]);

  const [state2, setState2] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [filteredOptions, setFilteredOptions] = useState([]);

  const [selectedVendor, setSelectedVendor] = useState(null);
  const [filteredVendor, setFilterVendor] = useState([]);
  const [item_master_id, setItem_master_id] = useState("");

  const [condition, setCondition] = useState("");
  const [vendor_asset_Id, setVendor_Asset_Id] = useState("");
  const [salvage_value, setSalvageValue] = useState("");
  const [quantity, setQuantity] = useState("1");
  const [quantityError, setQuantityError] = useState("");
  const [serialRows, setSerialRows] = useState([{ serial_number: "" }]);

  const [attachment, setAttachment] = useState(null);
  const [documents, setDocuments] = useState([]);

  const handleQuantityChange = (e) => {
    const rawValue = e.target.value;
    setQuantity(rawValue);

    const value = parseInt(rawValue, 10);
    if (rawValue === "" || isNaN(value) || value < 1) {
      setQuantityError(t("Quantity must be at least 1"));
      return;
    }

    setQuantityError("");
    setSerialRows((prevRows) => {
      const rows = [...prevRows];
      if (value > rows.length) {
        while (rows.length < value) {
          rows.push({ serial_number: "" });
        }
      } else {
        rows.length = value;
      }
      return rows;
    });
  };

  const handleSerialNumberChange = (index, value) => {
    setSerialRows((prevRows) => {
      const rows = [...prevRows];
      rows[index] = { ...rows[index], serial_number: value };
      return rows;
    });
  };

  const handleAddressforInstall = () => {
    form3.current.validateAll();
    if (checkBtn3.current.context._errors.length === 0) {
      AddPartyAddressService.addPartyAddress(
        party_id,
        installaddress_line_1,
        installaddress_line_2,
        installcity,
        installstateaddress,
        installzip_code,
        installcountry,
        installbill_to,
        installship_to,
        installinstall_to
      ).then((response) => {
        if (response.data.success) {
          toast.success(`${response.data.response}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          reset({
            address_id: response.data.addressId,
          });
          setReg_address(response.data.addressId);
          setTimeout(() => {
            getaddress(response.data.addressId);
            setState2({ isPaneOpen: false });
          }, 1000);
          setInstallAddress_line_1("");
          setInstallAddress_line_2("");
          setInstallCity("");
          setInstallStateAddress("");
          setInstallZip_code("");
          setInstallCountry("");
        } else {
          toast.error(`${response.data.error}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      });
    }
  };

  const handleshowhide = (e) => {
    const getuser = e.target.value;
    setCustomer_type(e.target.value);
    setShowHide(getuser);
  };

  const loadOptionInstallAdd = async (inputValue, callback) => {
    const filteredOptions = reg_address1
      .filter((address) =>
        `${address.address_line_1}, ${address.address_line_2}, ${address.city}, ${address.state}, ${address.country}`
          .toLowerCase()
          .includes(inputValue.toLowerCase())
      )
      .map((address) => ({
        value: address.id,
        label: `${address.address_line_1}, ${address.address_line_2}, ${address.city}, ${address.state}, ${address.country}`,
      }));

    setFilteredOptions(filteredOptions);
    callback(filteredOptions);
  };

  useEffect(() => {
    const options = reg_address1.map((address) => ({
      value: address.id,
      label: `${address.address_line_1}, ${address.address_line_2}, ${address.city}, ${address.state}, ${address.country}`,
    }));
    setFilteredOptions(options);
  }, [customer_name, reg_address, reg_address1]);

  const handleAddressChange = (selectedOption) => {
    if (selectedOption) {
      setReg_address(selectedOption.value);
      setSelectedAddress(selectedOption.value);
      reset({ address_id: selectedOption.value });
    } else {
      setReg_address(null);
      setSelectedAddress(null);
      reset({
        address_id: null,
      });
    }
  };

  const handleAddress = (id) => {
    form2.current.validateAll();
    if (checkBtn2.current.context._errors.length === 0) {
      AddPartyAddressService.addPartyAddress(
        id,
        address_line_1,
        address_line_2,
        city,
        stateaddress,
        zip_code,
        country,
        bill_to,
        ship_to,
        install_to
      ).then((response) => {
        if (response.data.success) {
          setSuccessful(true);
          setAddress_line_1("");
          setAddress_line_2("");
          setCity("");
          setStateAddress("");
          setZip_code("");
        }
      });
    }
  };

  const handleparty = () => {
    form2.current.validateAll();
    let establishmentDate = null;
    let dateofbirth = null;
    if (checkBtn2.current.context._errors.length === 0) {
      if (date_of_birth) {
        dateofbirth = Helper.DatePicker(date_of_birth);
      } else {
        setDate_of_birth(date_of_birth);
      }
      if (establishment_date) {
        establishmentDate = Helper.DatePicker(establishment_date);
      } else {
        setEstablishment(establishment_date);
      }
      AddPartyService.addParty(customer_type, party_type, customer_name).then(
        (response) => {
          if (response.data.success) {
            setSuccessful(true);
            setDisable(true);
            toast.success(`${response.data.response}`, {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            reset({
              vendorname1: response.data.partyId,
            });
            setVendor_name(response.data.partyId);
            handleAddress(response.data.partyId);
            setTimeout(() => {
              handelDefault();
              setState({ isPaneOpen: false });
            }, 1000);
            setCustomer_name("");
            setCustomer_type("");
          } else {
            setLoading(false);
            setSuccessful(false);
            toast.error(`${response.data.error}`, {
              position: "top-right",
              autoClose: 9000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          }
        }
      );
    }
  };

  const handlepartydefault = () => {
    AddPartyService.partyvalidate(customer_name).then((response) => {
      if (response.data.success) {
        handleparty();
      } else {
        confirmAlert({
          title: "",
          message: `Party ${customer_name} is available.`,
          // message: 'Party Vendor with the same name already exist. Are you sure you want to add party vender?.',
          buttons: [
            {
              // label: 'Yes',
              label: "OK",
              // onClick: () => handleparty()
            },
            // {
            //     label: "No",
            // }
          ],
        });
      }
    });
  };

  const handleCancel = () => {
    if (contract_term === "Loan") {
      setHideShowEdit(true);
    } else {
      setHideShowEdit(true);
    }
  };

  const getExtrafiled = () => {
    setIsLoading(true);
    GetCompanyInfoService.getExtraFiled().then((response) => {
      setExtraFiled(response.data.existcontractasset);
      // setTimeout(() => {
      setIsLoading(false);
      // }, 1000);
    });
  };

  const getaddress = async (id) => {
    if (id !== undefined) {
      setIsLoading(true);
      const resst = await fetch(
        API +
        "parties/manage-addressinstall/" +
        contractId +
        "/?address_type=install_to",
        { headers: authHeader() }
      );
      const getst = await resst.json();
      setReg_address1(await getst.data);
      // setReg_address(id)
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    } else {
      setIsLoading(true);
      const resst = await fetch(
        API +
        "parties/manage-addressinstall/" +
        contractId +
        "/?address_type=install_to",
        { headers: authHeader() }
      );
      const getst = await resst.json();
      setReg_address1(await getst.data);
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    }
  };

  const handelDefault = async () => {
    setIsLoading(true);
    const rsst = await fetch(API + "parties/vendor/?party_type=Vendor", {
      headers: authHeader(),
    });
    const gtst = await rsst.json();
    setVendorName(await gtst);
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  };

  useEffect(() => {
    getaddress();
    handelDefault();
    AddcategoryService.viewListCategory().then((response) => {
      setCategory_list(response.data.data.categories);
    });
  }, []);

  const handleCategoryChange = (e) => {
    setSelected_category(e.target.value);
    setSelected_sub_category("");
  }

  const handlesubCategoryChange = (e) => {
    setSelected_sub_category(e.target.value);
  }

  useEffect(() => {
    if (selected_category !== "") {
      const matchedCategory = category_list.find(
        (cat) => cat.id === Number(selected_category)
      )
      const category_name = matchedCategory?.category_name;
      if (category_name) {
        AddcategoryService.filtersubCategory(category_name).then((response) => {
          setSub_categories(response.data.sub_categories);
        });
      }
    } else {
      setSub_categories([]);
    }
  }, [selected_category, category_list])

  const editAsset = () => {
    setIsLoading(true);
    EditAssetService.getAsset(asset_id).then((response) => {
      setAsset_number(response.data.asset_number);
      setAsset_desc(response.data.asset_desc);
      setLicense_number(response.data.license_number);
      setFinanced_amount(response.data.financed_amount);
      setYear(response.data.year);
      setVin_number(response.data.vin_number);
      setLicense_state(response.data.license_state);
      setDealer_payable(response.data.dealer_payable);
      setManufacturer(response.data.manufacturer);
      setMake(response.data.make);
      setModel(response.data.model);
      setUser_purpose(response.data.user_purpose);
      seTresidal_value(response.data.residal_value);
      setReg_address(response.data.reg_address);
      setVendor_name(response.data.vendor_name);
      setDelivery_date(response.data.delivery_date);
      setIn_service_date(response.data.in_service_date);
      setMilage(response.data.milage);
      setVehicle_cost(response.data.vehicle_cost);
      setVehicle_cost_payto(response.data.vehicle_cost_payto);
      setTax_amount(response.data.tax_amount);
      setTax_amount_payto(response.data.tax_amount_payto);
      setTrade_in(response.data.trade_in);
      setTrade_in_payto(response.data.trade_in_payto);
      setReg_cost(response.data.reg_cost);
      setReg_cost_payto(response.data.reg_cost_payto);
      setTotal_cost(response.data.total_cost);
      setDown_payment(response.data.down_payment);
      setDown_payment_payto(response.data.down_payment_payto);
      setAssetType(response.data.assettype);
      setItem_master_id(response.data.item_master);
      setCondition(response.data.condition);
      setVendor_Asset_Id(response.data.vendorAssetId);
      setSalvageValue(response.data.salvageValue);
      setQuantity(String(response.data.quantity || 1));
      setQuantityError("");
      setSerialRows(
        response.data.serial_numbers && response.data.serial_numbers.length > 0
          ? response.data.serial_numbers.map((row) => ({
              serial_number: row.serial_number || "",
            }))
          : [{ serial_number: "" }]
      );
      setSelected_category(response.data.category ? String(response.data.category) : "");
      setSelected_sub_category(response.data.sub_category ? String(response.data.sub_category) : "");

      setAttribute([
        { attribute: response.data.assetattribute1 },
        { attribute: response.data.assetattribute2 },
        { attribute: response.data.assetattribute3 },
        { attribute: response.data.assetattribute4 },
        { attribute: response.data.assetattribute5 },
        { attribute: response.data.assetattribute6 },
        { attribute: response.data.assetattribute7 },
        { attribute: response.data.assetattribute8 },
        { attribute: response.data.assetattribute9 },
        { attribute: response.data.assetattribute10 },
        { attribute: response.data.assetattribute11 },
        { attribute: response.data.assetattribute12 },
        { attribute: response.data.assetattribute13 },
        { attribute: response.data.assetattribute14 },
        { attribute: response.data.assetattribute15 },
      ]);
      // setTimeout(() => {
      setIsLoading(false);
      // }, 1000);
      reset({
        assetno: response.data.asset_number,
        address_id: response.data.reg_address,
        vendorname1: response.data.vendor_name,
        vehiclecost: response.data.vehicle_cost,
      });
    });
  };
  useEffect(() => {
    setIsLoading(true);
    EditAssetService.getAsset(asset_id).then((response) => {
      setAsset_number(response.data.asset_number);
      setAsset_desc(response.data.asset_desc);
      setLicense_number(response.data.license_number);
      setFinanced_amount(response.data.financed_amount);
      setYear(response.data.year);
      setVin_number(response.data.vin_number);
      setLicense_state(response.data.license_state);
      setDealer_payable(response.data.dealer_payable);
      setManufacturer(response.data.manufacturer);
      setMake(response.data.make);
      setModel(response.data.model);
      setUser_purpose(response.data.user_purpose);
      seTresidal_value(response.data.residal_value);
      setReg_address(response.data.reg_address);
      setVendor_name(response.data.vendor_name);
      setDelivery_date(response.data.delivery_date);
      setIn_service_date(response.data.in_service_date);
      setMilage(response.data.milage);
      setVehicle_cost(response.data.vehicle_cost);
      setVehicle_cost_payto(response.data.vehicle_cost_payto);
      setTax_amount(response.data.tax_amount);
      setTax_amount_payto(response.data.tax_amount_payto);
      setTrade_in(response.data.trade_in);
      setTrade_in_payto(response.data.trade_in_payto);
      setReg_cost(response.data.reg_cost);
      setReg_cost_payto(response.data.reg_cost_payto);
      setTotal_cost(response.data.total_cost);
      setDown_payment(response.data.down_payment);
      setDown_payment_payto(response.data.down_payment_payto);
      setAssetType(response.data.assettype);
      setItem_master_id(response.data.item_master);
      setCondition(response.data.condition);
      setVendor_Asset_Id(response.data.vendorAssetId);
      setSalvageValue(response.data.salvageValue);
      setQuantity(String(response.data.quantity || 1));
      setQuantityError("");
      setSerialRows(
        response.data.serial_numbers && response.data.serial_numbers.length > 0
          ? response.data.serial_numbers.map((row) => ({
              serial_number: row.serial_number || "",
            }))
          : [{ serial_number: "" }]
      );
      setSelected_category(response.data.category ? String(response.data.category) : "");
      setSelected_sub_category(response.data.sub_category ? String(response.data.sub_category) : "");

      setAttribute([
        { attribute: response.data.assetattribute1 },
        { attribute: response.data.assetattribute2 },
        { attribute: response.data.assetattribute3 },
        { attribute: response.data.assetattribute4 },
        { attribute: response.data.assetattribute5 },
        { attribute: response.data.assetattribute6 },
        { attribute: response.data.assetattribute7 },
        { attribute: response.data.assetattribute8 },
        { attribute: response.data.assetattribute9 },
        { attribute: response.data.assetattribute10 },
        { attribute: response.data.assetattribute11 },
        { attribute: response.data.assetattribute12 },
        { attribute: response.data.assetattribute13 },
        { attribute: response.data.assetattribute14 },
        { attribute: response.data.assetattribute15 },
      ]);
      // setTimeout(() => {
      setIsLoading(false);
      // }, 1000);
      reset({
        assetno: response.data.asset_number,
        address_id: response.data.reg_address,
        vendorname1: response.data.vendor_name,
        vehiclecost: response.data.vehicle_cost,
      });
    });
  }, []);

  const handlepayment = () => {
    setIsLoading(true);
    let url = API + "contracts/paymentschedule-view/" + contractId + "/";
    axios.get(url, { headers: authHeader() }).then((response) => {
      setItems(response.data.data);
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    });
  };

  const handleiir = () => {
    let url = API + "contracts/contractiir/?";
    url += "id=" + contractId;
    axios
      .get(url, { headers: authHeader() })
      .then((response) => console.log("data", response.data));
  };

  const handlefinanced = () => {
    let url = API + "contracts/financedamount/" + contractId + "/";
    axios
      .get(url, { headers: authHeader() })
      .then((response) => console.log("data", response.data));
  };
  const handlevin = () => {
    setIsLoading(true);
    let url = `https://vpic.nhtsa.dot.gov/api/vehicles/decodevinvalues/${vin_number}?format=json`;
    axios.get(url, { headers: authHeader() }).then((response) => {
      setVinDecode(response.data);
      setMake(response.data.Results[0].Make);
      setModel(response.data.Results[0].Model);
      setManufacturer(response.data.Results[0].Manufacturer);
      setYear(response.data.Results[0].ModelYear);
      // setTimeout(() => {
      setIsLoading(false);
      // }, 1000);
    });
  };

  const [disablebutton, setDisablebutton] = useState(false);

  // const generateRandomSerialNumber = (length = 10) => {
  //     const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  //     let serialNumber = '';
  //     for (let i = 0; i < length; i++) {
  //         const randomIndex = Math.floor(Math.random() * chars.length);
  //         serialNumber += chars[randomIndex];
  //     }
  //     return serialNumber;
  // };

  const handleCreateItem = (asset_id, financed_amt) => {
    let itemid = "";
    let description = asset_desc;
    let itemname = "";
    let serial_number = "";
    let life_in_months = null;
    let netbookvalue = vehicle_cost;
    let originalcost = financed_amt;
    let status = "In Transit";
    let item_type = asset_type;
    // let asset_id =  id
    AddItemmasterService.addItemmaster(
      itemid,
      itemname,
      description,
      serial_number,
      year,
      manufacturer,
      model,
      make,
      Date,
      life_in_months,
      netbookvalue,
      originalcost,
      status,
      asset_id,
      item_type
    ).then((response) => {
      if (response.data.success === 1) {
        toast.success(`${response.data.response}`, {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setLoading(false);
      } else {
        setLoading(false);
        setDisable(false);
        toast.error(`${response.data.error}`, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    });
  };

  const handleRegister = () => {
    let dow_payment = null;
    let trad_in = null;
    let tax = null;
    let reg = null;
    let vehicle = null;
    if (tax_amount_payto === "Dealer") {
      tax = tax_amount;
    } else {
      tax = 0;
    }
    if (reg_cost_payto === "Dealer") {
      reg = reg_cost;
    } else {
      reg = 0;
    }
    if (down_payment_payto === "Dealer") {
      dow_payment = down_payment;
    } else {
      dow_payment = 0;
    }
    if (trade_in_payto === "Dealer") {
      trad_in = trade_in;
    } else {
      trad_in = 0;
    }
    if (vehicle_cost_payto === "Dealer") {
      vehicle = vehicle_cost;
    } else {
      vehicle = 0;
    }

    const total_cost =
      parseFloat(vehicle_cost) + parseFloat(tax_amount) + parseFloat(reg_cost);
    const financed_amt =
      parseFloat(total_cost) - parseFloat(trade_in) - parseFloat(down_payment);
    const dealer_pay =
      parseFloat(vehicle) +
      parseFloat(tax) +
      parseFloat(reg) -
      parseFloat(trad_in) -
      parseFloat(dow_payment);
    setSuccessful(false);
    setLoading(true);
    setDisablebutton(true);
    form.current.validateAll();
    let DelecieryDate = null;
    let Inservicedate = null;
    let residual = residal_value || 0;

    if (checkBtn.current.context._errors.length === 0) {
      if (in_service_date) {
        Inservicedate = Helper.DatePicker(in_service_date);
      } else {
        setIn_service_date(in_service_date);
      }
      if (delivery_date) {
        DelecieryDate = Helper.DatePicker(delivery_date);
      } else {
        setDelivery_date(delivery_date);
      }
      const quantityValue = parseInt(quantity, 10);
      if (quantityError || isNaN(quantityValue) || quantityValue < 1) {
        toast.error("Please enter a valid Quantity (1 or more)", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setLoading(false);
        setDisablebutton(false);
        return false;
      }
      if (asset_type !== "Equipment" && serialRows.some((row) => !row.serial_number)) {
        toast.error("Please enter VIN Number for each row", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setLoading(false);
        setDisablebutton(false);
        return false;
      }
      EditAssetService.addAsset(
        asset_id,
        asset_number,
        asset_desc,
        license_number,
        financed_amt,
        year,
        vin_number,
        license_state,
        dealer_pay,
        manufacturer,
        make,
        model,
        user_purpose,
        residual,
        reg_address,
        vendor_name,
        DelecieryDate,
        Inservicedate,
        milage,
        vehicle_cost,
        vehicle_cost_payto,
        tax_amount,
        tax_amount_payto,
        trade_in,
        trade_in_payto,
        reg_cost,
        reg_cost_payto,
        total_cost,
        down_payment,
        down_payment_payto,
        asset_type,
        attribute,
        item_master_id !== "" ? item_master_id : "",
        condition,
        vendor_asset_Id,
        salvage_value,
        quantityValue,
        serialRows.map((row) => ({ serial_number: row.serial_number })),
        selected_category !== "" ? selected_category : "",
        selected_sub_category !== "" ? selected_sub_category : "",
      ).then((response) => {
        if (response.data.success) {
          setSuccessful(true);
          setLoading(false);
          if (asset_desc !== null) {
            if (item_master_id === "" || item_master_id === null) {
              // Inventory records should only be created during contract activation, not during asset entry. Disabled per request.
              // let asset_id = response.data.id;
              // handleCreateItem(asset_id, financed_amt);
            }
          }
          setTimeout(() => {
            setDisablebutton(false);
            if (contract_term === "Loan") {
              setHideShowEdit(true);
              handlepayment();
              handlefinanced();
            } else {
              handleiir();
              handlefinanced();
              setHideShowEdit(true);
            }
          }, 2000);
          toast.success(`${response.data.response}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          setLoading(false);
          setDisablebutton(false);
          toast.error(`${response.data.error}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setSuccessful(false);
        }
      });
    }
  };
  const handleSave = () => {
    let dow_payment = null;
    let trad_in = null;
    let tax = null;
    let reg = null;
    let vehicle = null;
    if (tax_amount_payto === "Dealer") {
      tax = tax_amount;
    } else {
      tax = 0;
    }
    if (reg_cost_payto === "Dealer") {
      reg = reg_cost;
    } else {
      reg = 0;
    }
    if (down_payment_payto === "Dealer") {
      dow_payment = down_payment;
    } else {
      dow_payment = 0;
    }
    if (trade_in_payto === "Dealer") {
      trad_in = trade_in;
    } else {
      trad_in = 0;
    }
    if (vehicle_cost_payto === "Dealer") {
      vehicle = vehicle_cost;
    } else {
      vehicle = 0;
    }

    const total_cost =
      parseFloat(vehicle_cost) + parseFloat(tax_amount) + parseFloat(reg_cost);
    const financed_amt =
      parseFloat(total_cost) - parseFloat(trade_in) - parseFloat(down_payment);
    const dealer_pay =
      parseFloat(vehicle) +
      parseFloat(tax) +
      parseFloat(reg) -
      parseFloat(trad_in) -
      parseFloat(dow_payment);
    setSuccessful(false);
    form.current.validateAll();
    let DelecieryDate = null;
    let Inservicedate = null;
    let residual = residal_value || 0;

    if (checkBtn.current.context._errors.length === 0) {
      if (in_service_date) {
        Inservicedate = Helper.DatePicker(in_service_date);
      } else {
        setIn_service_date(in_service_date);
      }
      if (delivery_date) {
        DelecieryDate = Helper.DatePicker(delivery_date);
      } else {
        setDelivery_date(delivery_date);
      }
      const quantityValue = parseInt(quantity, 10);
      if (quantityError || isNaN(quantityValue) || quantityValue < 1) {
        toast.error("Please enter a valid Quantity (1 or more)", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setLoading(false);
        setDisablebutton(false);
        return false;
      }
      if (asset_type !== "Equipment" && serialRows.some((row) => !row.serial_number)) {
        toast.error("Please enter VIN Number for each row", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setLoading(false);
        setDisablebutton(false);
        return false;
      }
      EditAssetService.addAsset(
        asset_id,
        asset_number,
        asset_desc,
        license_number,
        financed_amt,
        year,
        vin_number,
        license_state,
        dealer_pay,
        manufacturer,
        make,
        model,
        user_purpose,
        residual,
        reg_address,
        vendor_name,
        DelecieryDate,
        Inservicedate,
        milage,
        vehicle_cost,
        vehicle_cost_payto,
        tax_amount,
        tax_amount_payto,
        trade_in,
        trade_in_payto,
        reg_cost,
        reg_cost_payto,
        total_cost,
        down_payment,
        down_payment_payto,
        asset_type,
        attribute,
        item_master_id !== "" ? item_master_id : "",
        condition,
        vendor_asset_Id,
        salvage_value,
        quantityValue,
        serialRows.map((row) => ({ serial_number: row.serial_number })),
        selected_category !== "" ? selected_category : "",
        selected_sub_category !== "" ? selected_sub_category : "",
      ).then(async (response) => {
        if (response.data.success) {
          setSuccessful(true);

          let updatedAssetId = asset_id; // use existing id

          // 🔥 ADD HERE (RIGHT AFTER SUCCESS)
          if (attachment) {
            const formData = new FormData();

            formData.append("file", attachment);
            formData.append("title", attachment.name);
            formData.append("description", "Asset Attachment");
            formData.append("tags", "asset");
            formData.append("reference_id", contractId);
            formData.append("reference_name", "Contract");
            formData.append("doc_type", "Other");

            try {
              const res = await DocumentUpload.excelfileDocument(formData);
              console.log("Upload success:", res.data);

              await getDocuments();

            } catch (err) {
              console.error("Upload error:", err);
            }
          }

          if (asset_desc !== null) {
            if (item_master_id === "" || item_master_id === null) {
              // Inventory records should only be created during contract activation, not during asset entry. Disabled per request.
              // let asset_id = response.data.id;
              // handleCreateItem(asset_id, financed_amt);
            }
          }
          setTimeout(() => {
            if (contract_term === "Loan") {
              editAsset();
              handlefinanced();
              handlepayment();
            } else {
              handleiir();
              editAsset();
              handlefinanced();
            }
          }, 2000);
          toast.success(`${response.data.response}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          toast.error(`${response.data.error}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setSuccessful(false);
        }
      });
    }
  };

  useEffect(() => {
    getExtrafiled();
  }, []);

  const onChangeextrafileds = (e, index) => {
    const { name, value } = e.target;
    const rowsInput = [...attribute];
    rowsInput[index][name] = value;
    setAttribute(rowsInput);
  };

  const loadOptionVendorName = async (inputValue, callback) => {
    const filteredOptions = vendorname
      .filter((val) =>
        val.customer_name.toLowerCase().includes(inputValue.toLowerCase())
      )
      .map((values) => ({
        value: values.id,
        label: values.customer_name,
      }));

    setFilterVendor(filteredOptions);
    callback(filteredOptions);
  };

  useEffect(() => {
    const options = vendorname.map((val) => ({
      value: val.id,
      label: val.customer_name,
    }));
    setFilterVendor(options);
  }, [vendorname]);

  const handleVendorChange = (selectedOption) => {
    if (selectedOption) {
      setSelectedVendor(selectedOption.value);
      setVendor_name(selectedOption.value);
      reset({
        vendorname1: selectedOption.value,
      });
    } else {
      setSelectedVendor(null);
      setVendor_name(null);
      reset({
        vendorname1: null,
      });
    }
  };

  const handelSearch = () => {
    let item_type = asset_type;
    axios
      .get(
        `${API}contracts/search/itemmaster/?description=&contract_id=${contractId}&item_type=${item_type}&itemname=${selectedValue ? selectedValue.itemname : ""
        }&serialnumber=${selectedValue2 ? selectedValue2.serialnumber : ""
        }&model=${selectedValue3 ? selectedValue3.model : ""}&make=${selectedValue4 ? selectedValue4.make : ""
        }&manufacturer=${selectedValue6 ? selectedValue6.manufacturer : ""}`,
        {
          headers: authHeader(),
        }
      )
      .then((res) => {
        const optionsList = res.data.map((val) => val);
        setOptions(optionsList);
        // let asset_des = optionsList[0]?.description.trim();
        // setAsset_desc(asset_des)
        // setItem_master_id(optionsList.map((val) => val.id))
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  useEffect(() => {
    let item_type = asset_type;
    axios
      .get(
        `${API}contracts/search/itemmaster/?description=${asset_desc}&contract_id=${contractId}&item_type=${item_type}&itemname=${selectedValue ? selectedValue.itemname : ""
        }&serialnumber=${selectedValue2 ? selectedValue2.serialnumber : ""
        }&model=${selectedValue3 ? selectedValue3.model : ""}&make=${selectedValue4 ? selectedValue4.make : ""
        }&manufacturer=${selectedValue6 ? selectedValue6.manufacturer : ""}`,
        {
          headers: authHeader(),
        }
      )
      .then((res) => {
        const optionsList = res.data.map((val) => val);
        setOptions(optionsList);
        // setState3({ isPaneOpen: true });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [state3]);

  const [selectedValue, setSelectedValue] = useState("");
  const [selectedValue2, setSelectedValue2] = useState("");
  const [selectedValue3, setSelectedValue3] = useState("");
  const [selectedValue4, setSelectedValue4] = useState("");
  const [inputvalue3, setValue3] = useState("");
  const [inputvalue4, setValue4] = useState("");
  const [inputvalue, setValue] = useState("");
  const [inputvalue2, setValue2] = useState("");
  const [inputvalue6, setValue6] = useState("");

  const [selectedValue6, setSelectedValue6] = useState("");

  const handleClear = () => {
    setSelectedValue("");
    setSelectedValue2("");
    setSelectedValue3("");
    setSelectedValue4("");
    // setSelectedValue5("");
    setSelectedValue6("");
    setAsset_desc("");
    setItem_master_id("");
    setYear("");
    setMake("");
    setModel("");
    setManufacturer("");
    setOptions([]);
    setVehicle_cost(0);
  };



  const getDocuments = async () => {
    try {
      const res = await DocumentUpload.viewListuploadFilterview(
        "contract",
        contractId
      );

      console.log("Documents:", res.data);

      setDocuments(res.data.data || res.data.results || []);

    } catch (err) {
      console.error(err);
    }
  };


  useEffect(() => {
    if (asset_id) {
      getDocuments();
    }
  }, [asset_id]);

  const loadOptions = async (inputValue) => {
    if (inputValue !== "") {
      const responseJSON = await axios.get(
        API + `contracts/itemmaster/filter/?itemname=${inputValue}`,
        { headers: authHeader() }
      );
      return responseJSON.data.data;
    }
  };

  const handelInputChange = (value) => {
    setValue(value);
  };

  const handelChange = (value) => {
    setSelectedValue(value);
  };

  const handelInputChange2 = (value1) => {
    setValue2(value1);
  };

  const handelChange2 = (value1) => {
    setSelectedValue2(value1);
  };
  const handelInputChange6 = (value1) => {
    setValue6(value1);
  };

  const loadOptions2 = async (inputValue2) => {
    if (inputValue2 !== "") {
      const response = await axios.get(
        API + `contracts/itemmaster/filter/?serialnumber=${inputValue2}`,
        { headers: authHeader() }
      );
      return response.data.data;
    }
  };

  const handelChange3 = (value1) => {
    setSelectedValue3(value1);
  };

  const handelInputChange3 = (value1) => {
    setValue3(value1);
  };

  const loadOptions3 = async (inputValue3) => {
    if (inputValue3 !== "") {
      const response = await axios.get(
        API + `contracts/itemmaster/filter/?model=${inputValue3}`,
        { headers: authHeader() }
      );
      return response.data.data;
    }
  };

  const handelChange4 = (value1) => {
    setSelectedValue4(value1);
  };

  const loadOptions4 = async (inputValue4) => {
    if (inputValue4 !== "") {
      const response = await axios.get(
        API + `contracts/itemmaster/filter/?make=${inputValue4}`,
        { headers: authHeader() }
      );
      return response.data.data;
    }
  };

  const handelInputChange4 = (value1) => {
    setValue4(value1);
  };

  const handelChange6 = (value1) => {
    setSelectedValue6(value1);
  };

  const loadOptions6 = async (inputValue6) => {
    if (inputValue6 !== "") {
      const response = await axios.get(
        API + `contracts/itemmaster/filter/?manufacturer=${inputValue6}`,
        { headers: authHeader() }
      );
      return response.data.data;
    }
  };

  const handleTagClick = (tag) => {
    setItem_master_id(tag.id);
    setTimeout(() => {
      setState3({ isPaneOpen: false });
    }, 1000);
  };

  useEffect(() => {
    if (item_master_id) {
      EditItemMasterService.getItemmaster(item_master_id).then((response) => {
        setAsset_desc(response.data.description);
        setYear(response.data.yearofmanufacture);
        setMake(response.data.make);
        setModel(response.data.model);
        setManufacturer(response.data.manufacturer);
        setVehicle_cost(response.data.netbookvalue);
        setLoading(false);
      });
    }
  }, [item_master_id]);

  return (
    <>
      {hideshowedit === false ? (
        <div className="container-fluid">
          <ToastContainer />
          <SlidingPane
            className="some-custom-class sidepanebar"
            isOpen={state2.isPaneOpen}
            title="Add Address"
            subtitle=""
            onRequestClose={() => {
              setState2({ isPaneOpen: false });
            }}
          >
            <Form
              role="form text-left"
              onSubmit={handleSubmit3(handleAddressforInstall)}
              ref={form3}
              key={3}
              action="."
              method="POST"
              id="addReceiptForm"
            >
              {
                <>
                  <div className="row">
                    <div className="form-group row">
                      <div className="col-md-6">
                        <label className="col-form-label required">
                          {t("Address Line 1")}{" "}
                          <Tooltip content={t("Address_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("Address Line 1")}
                          className="form-control"
                          type="text"
                          name="installaddress_line_1"
                          maxLength="200"
                          id="id_address_line_1"
                          value={installaddress_line_1}
                          {...register3("installaddress_line_1", {
                            onChange: (e) => {
                              setInstallAddress_line_1(e.target.value);
                            },
                            required: true,
                          })}
                        />
                        <div className="invalid-feedback">
                          {errors3.installaddress_line_1?.type === "required" &&
                            "Address is required"}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <label className="col-form-label">
                          {t("Address Line 2")}{" "}
                          <Tooltip content={t("Address2_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("Address Line 2")}
                          className="form-control"
                          type="text"
                          onChange={(e) =>
                            setInstallAddress_line_2(e.target.value)
                          }
                          name="installaddress_line_2"
                          maxLength="200"
                          id="id_address_line_2"
                          value={installaddress_line_2}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-6">
                        <label className="col-form-label required">
                          {t("City")}{" "}
                          <Tooltip content={t("City_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("City")}
                          className="form-control"
                          type="text"
                          name="installcity"
                          maxLength="100"
                          id="id_city"
                          value={installcity}
                          {...register3("installcity", {
                            onChange: (e) => {
                              setInstallCity(e.target.value);
                            },
                            required: true,
                          })}
                        />
                        <div className="invalid-feedback">
                          {errors3.installcity?.type === "required" &&
                            "City is required"}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <label className="col-form-label required">
                          {t("State")}{" "}
                          <Tooltip content={t("State_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("State")}
                          className="form-control"
                          type="text"
                          name="installstate"
                          maxLength="30"
                          id="id_state"
                          value={installstateaddress}
                          {...register3("installstate", {
                            onChange: (e) => {
                              setInstallStateAddress(e.target.value);
                            },
                            required: true,
                          })}
                        />
                        <div className="invalid-feedback">
                          {errors3.installstate?.type === "required" &&
                            "State is required"}
                        </div>
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-6">
                        <label className="col-form-label required">
                          {t("Zip Code")}{" "}
                          <Tooltip content={t("ZipCode_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("Zip Code")}
                          className="form-control"
                          type="text"
                          name="installzip_code"
                          maxLength="30"
                          id="id_zip_code"
                          value={installzip_code}
                          {...register3("installzip_code", {
                            onChange: (e) => {
                              setInstallZip_code(e.target.value);
                            },
                            required: true,
                          })}
                        />
                        <div className="invalid-feedback">
                          {errors3.installzip_code?.type === "required" &&
                            "Zip Code is required"}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <label className="col-form-label required">
                          {t("Country")}{" "}
                          <Tooltip content={t("Country_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("Country")}
                          className="form-control"
                          type="text"
                          name="installcountry"
                          maxLength="50"
                          id="id_country"
                          value={installcountry}
                          {...register3("installcountry", {
                            onChange: (e) => {
                              setInstallCountry(e.target.value);
                            },
                            required: true,
                          })}
                        />
                        <div className="invalid-feedback">
                          {errors3.installcountry?.type === "required" &&
                            "Country is required"}
                        </div>
                      </div>
                    </div>
                  </div>
                  <button
                    type="submit"
                    className="border-0 btn btn-primary btn-gradient-primary btn-md"
                  >
                    {t("Save")}
                  </button>
                  &nbsp;&nbsp;
                </>
              }
              <CheckButton style={{ display: "none" }} ref={checkBtn3} />
            </Form>
          </SlidingPane>
          <SlidingPane
            className="some-custom-class sidepanebar"
            isOpen={state1.isPaneOpen}
            title="Add Vendor"
            subtitle=""
            onRequestClose={() => {
              setState({ isPaneOpen: false });
            }}
          >
            <Form
              role="form text-left"
              onSubmit={handleSubmit2(handlepartydefault)}
              ref={form2}
              key={2}
              action="."
              method="POST"
              id="addReceiptForm"
            >
              {
                <>
                  <div className="row">
                    <div className="col-md-6">
                      <label className="col-form-label required">
                        {t("Party Type")}{" "}
                        <Tooltip content={t("PartyType_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <div className="form-group row">
                        <div
                          className="form-check"
                          style={{ width: "25%", paddingLeft: "3.0em" }}
                        >
                          <input
                            className="form-check-input"
                            checked={party_type === "Vendor" ? true : false}
                            value="Vendor"
                            type="radio"
                            name="vendor"
                            id="flexRadioDefault2"
                            onChange={(e) => setParty_type(e.target.value)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexRadioDefault2"
                          >
                            Vendor
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <label className="col-form-label required">
                      {t("Entity Type")}{" "}
                      <Tooltip content={t("EntityType_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>
                    <div className="form-group row">
                      <div
                        className="form-check"
                        style={{ width: "25%", paddingLeft: "2.73em" }}
                      >
                        <input
                          className="form-check-input"
                          checked={customer_type === "Person" ? true : false}
                          value="Person"
                          type="radio"
                          name="person"
                          id="id_customer_type"
                          {...register2("customer_type", {
                            onChange: (e) => {
                              handleshowhide(e);
                            },
                            required: true,
                          })}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexRadioDefault1"
                        >
                          Person
                        </label>
                      </div>
                      <div
                        className="form-check"
                        style={{ width: "25%", paddingLeft: "4.73em" }}
                      >
                        <input
                          className="form-check-input"
                          checked={
                            customer_type === "Organization" ? true : false
                          }
                          value="Organization"
                          type="radio"
                          name="organization"
                          id="id_customer_type"
                          {...register2("customer_type", {
                            onChange: (e) => {
                              handleshowhide(e);
                            },
                            required: true,
                          })}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexRadioDefault1"
                        >
                          Organization
                        </label>
                      </div>
                    </div>

                    <div className="invalid-feedback">
                      {errors2.customer_type?.type === "required" &&
                        "Entity Type  is required"}
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-md-12">
                      <label className="col-form-label required">
                        {t("Party Name")}{" "}
                        <Tooltip content={t("PartyName_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <input
                        placeholder={t("Party Name")}
                        className="form-control"
                        type="text"
                        value={customer_name}
                        name="customer_name"
                        maxLength="200"
                        id="id_customer_name"
                        {...register2("customer_name", {
                          onChange: (e) => {
                            setCustomer_name(e.target.value);
                          },
                          required: true,
                        })}
                      />
                      <div className="invalid-feedback">
                        {errors2.customer_name?.type === "required" &&
                          "Party Name  is required"}
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-6">
                        <label className="col-form-label required">
                          {t("Address Line 1")}{" "}
                          <Tooltip content={t("Address_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("Address Line 1")}
                          className="form-control"
                          type="text"
                          name="address_line_1"
                          maxLength="200"
                          id="id_address_line_1"
                          value={address_line_1}
                          {...register2("address_line_1", {
                            onChange: (e) => {
                              setAddress_line_1(e.target.value);
                            },
                            required: true,
                          })}
                        />
                        <div className="invalid-feedback">
                          {errors2.address_line_1?.type === "required" &&
                            "Address is required"}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <label className="col-form-label">
                          {t("Address Line 2")}{" "}
                          <Tooltip content={t("Address2_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("Address Line 2")}
                          className="form-control"
                          type="text"
                          onChange={(e) => setAddress_line_2(e.target.value)}
                          name="address_line_2"
                          maxLength="200"
                          id="id_address_line_2"
                          value={address_line_2}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-6">
                        <label className="col-form-label required">
                          {t("City")}{" "}
                          <Tooltip content={t("City_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("City")}
                          className="form-control"
                          type="text"
                          name="city"
                          maxLength="100"
                          id="id_city"
                          value={city}
                          {...register2("city", {
                            onChange: (e) => {
                              setCity(e.target.value);
                            },
                            required: true,
                          })}
                        />
                        <div className="invalid-feedback">
                          {errors2.city?.type === "required" &&
                            "City is required"}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <label className="col-form-label required">
                          {t("State")}{" "}
                          <Tooltip content={t("State_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("State")}
                          className="form-control"
                          type="text"
                          name="state"
                          maxLength="30"
                          id="id_state"
                          value={stateaddress}
                          {...register2("state", {
                            onChange: (e) => {
                              setStateAddress(e.target.value);
                            },
                            required: true,
                          })}
                        />
                        <div className="invalid-feedback">
                          {errors2.state?.type === "required" &&
                            "State is required"}
                        </div>
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-6">
                        <label className="col-form-label required">
                          {t("Zip Code")}{" "}
                          <Tooltip content={t("ZipCode_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("Zip Code")}
                          className="form-control"
                          type="text"
                          name="zip_code"
                          maxLength="30"
                          id="id_zip_code"
                          value={zip_code}
                          {...register2("zip_code", {
                            onChange: (e) => {
                              setZip_code(e.target.value);
                            },
                            required: true,
                          })}
                        />
                        <div className="invalid-feedback">
                          {errors2.zip_code?.type === "required" &&
                            "Zip Code is required"}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <label className="col-form-label required">
                          {t("Country")}{" "}
                          <Tooltip content={t("Country_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("Country")}
                          className="form-control"
                          type="text"
                          name="country"
                          maxLength="50"
                          id="id_country"
                          value={country}
                          {...register2("country", {
                            onChange: (e) => {
                              setCountry(e.target.value);
                            },
                            required: true,
                          })}
                        />
                        <div className="invalid-feedback">
                          {errors2.country?.type === "required" &&
                            "Country is required"}
                        </div>
                      </div>
                    </div>
                  </div>
                  <button
                    type="submit"
                    className="border-0 btn btn-primary btn-gradient-primary btn-md"
                  >
                    {t("Save")}
                  </button>
                  &nbsp;&nbsp;
                </>
              }
              <CheckButton style={{ display: "none" }} ref={checkBtn2} />
            </Form>
          </SlidingPane>
          <SlidingPane
            className="some-custom-class sidepanebar"
            overlayClassName="custom-overlay"
            isOpen={state3.isPaneOpen}
            title="Filter By"
            onRequestClose={() => {
              setState3({ isPaneOpen: false });
            }}
          >
            <div className="col-md-12">
              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group">
                    <label className="col-form-label">{t("Item Number")}</label>
                    <AsyncSelect
                      defaultOptions
                      isClearable
                      placeholder={t("Search for Item Number (%for All)")}
                      value={selectedValue}
                      getOptionLabel={(e) => e.itemname}
                      getOptionValue={(e) => e.itemname}
                      loadOptions={loadOptions}
                      onInputChange={handelInputChange}
                      onChange={handelChange}
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group">
                    <label className="col-form-label">
                      {t("Serial Number")}
                    </label>
                    <AsyncSelect
                      defaultOptions
                      isClearable
                      placeholder={t("Search for Serial number(%for All)")}
                      value={selectedValue2}
                      getOptionLabel={(e) => e.serialnumber}
                      getOptionValue={(e) => e.serialnumber}
                      loadOptions={loadOptions2}
                      onInputChange={handelInputChange2}
                      onChange={handelChange2}
                    />
                    <input type="hidden" id="contract_status" value="" />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group">
                    <label className="col-form-label">{t("Model")}</label>
                    <AsyncSelect
                      defaultOptions
                      isClearable
                      placeholder={t("Search for Model(%for All)")}
                      value={selectedValue3}
                      getOptionLabel={(e) => e.model}
                      getOptionValue={(e) => e.model}
                      loadOptions={loadOptions3}
                      onInputChange={handelInputChange3}
                      onChange={handelChange3}
                    />
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="form-group">
                    <label className="col-form-label">{t("Make")}</label>
                    <AsyncSelect
                      defaultOptions
                      isClearable
                      placeholder={t("Search for Make(%for All)")}
                      value={selectedValue4}
                      getOptionLabel={(e) => e.make}
                      getOptionValue={(e) => e.make}
                      loadOptions={loadOptions4}
                      onInputChange={handelInputChange4}
                      onChange={handelChange4}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group">
                    <label className="col-lg-12 col-form-label">
                      {t("Manufacturer")}
                    </label>
                    {/* <div className="col-lg-12"> */}
                    <AsyncSelect
                      defaultOptions
                      isClearable
                      placeholder={t("Search for Manufacture(%for All)")}
                      value={selectedValue6}
                      getOptionLabel={(e) => e.manufacturer}
                      getOptionValue={(e) => e.manufacturer}
                      loadOptions={loadOptions6}
                      onInputChange={handelInputChange6}
                      onChange={handelChange6}
                      styles={{
                        menu: (provided) => ({
                          ...provided,
                          zIndex: 9999,
                        }),
                      }}
                    ></AsyncSelect>
                    {/* </div> */}
                    <input type="hidden" id="contract_status" value="" />
                  </div>
                </div>
              </div>

              <div className="col-lg-12">
                <button
                  type="button"
                  className="clearAll btn bg-gradient-secondary ms-auto mb-0 "
                  onClick={handleClear}
                >
                  {t("Reset")}
                </button>
                &nbsp;&nbsp;
                <button
                  type="button"
                  onClick={handelSearch}
                  className="partyFilter add btn btn-primary ms-auto mb-0"
                >
                  {t("Apply")}
                </button>
                &nbsp;&nbsp;
              </div>
              <div style={{ marginTop: "10px" }}>
                <MaterialTable
                  title="Inventory List"
                  columns={[
                    {
                      title: "",
                      render: (rowData) => (
                        <input
                          type="checkbox"
                          checked={item_master_id === rowData.id}
                          onChange={() => handleTagClick(rowData)}
                        />
                      ),
                      sorting: false,
                    },
                    {
                      title: `${t("Item name")}`,
                      field: "itemname",
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">
                            {t("Item name")}
                          </div>
                          <div>
                            {rowData.itemname ? rowData.itemname : "None"}
                          </div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Make")}`,
                      field: "make",
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">
                            {t("Make")}
                          </div>
                          <div>{rowData.make ? rowData.make : "None"}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Model")}`,
                      field: "model",
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">
                            {t("Model")}
                          </div>
                          <div>{rowData.model ? rowData.model : "None"}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Serial number")}`,
                      field: "serialnumber",
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">
                            {t("Serial number")}
                          </div>
                          <div>
                            {rowData.serialnumber
                              ? rowData.serialnumber
                              : "None"}
                          </div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Manufacturer")}`,
                      field: "manufacturer",
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">
                            {t("Manufacturer")}
                          </div>
                          <div>
                            {rowData.manufacturer
                              ? rowData.manufacturer
                              : "None"}
                          </div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Item Type")}`,
                      field: "item_type",
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">
                            {t("Item Type")}
                          </div>
                          <div>
                            {rowData.item_type ? rowData.item_type : "None"}
                          </div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Status")}`,
                      field: "status",
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">
                            {t("Status")}
                          </div>
                          <div>{rowData.status ? rowData.status : "None"}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                  ]}
                  detailPanel={[
                    {
                      render: (rowData) => (
                        <>
                          <div
                            className="col-md-12"
                            style={{ paddingLeft: "20px" }}
                          >
                            <div className=" row">
                              <div className="col-xl-3">
                                <label className="col-lg-12 col-form-label">
                                  {t("Item Number")}
                                </label>
                              </div>
                              <div className="col-xl-3">
                                <span className="col-lg-8 view-label p">
                                  {rowData.itemname ? rowData.itemname : "None"}
                                </span>
                              </div>
                              <div className="col-xl-3">
                                <label className="col-lg-12 col-form-label">
                                  {t("Status")}
                                </label>
                              </div>
                              <div className="col-xl-3">
                                <span className="col-lg-8 view-label p">
                                  {rowData.status}
                                </span>
                              </div>
                            </div>
                            <div className=" row">
                              <div className="col-xl-3">
                                <label className="col-lg-12 col-form-label">
                                  {t("Description")}
                                </label>
                              </div>
                              <div className="col-xl-3">
                                <span className="col-lg-8 view-label p">
                                  {rowData.description
                                    ? rowData.description
                                    : "None"}
                                </span>
                              </div>
                              <div className="col-xl-3">
                                <label className="col-lg-12 col-form-label">
                                  {t("Serial Number")}
                                </label>
                              </div>
                              <div className="col-xl-3">
                                <span className="col-lg-8 view-label p">
                                  {rowData.serial_number
                                    ? rowData.serial_number
                                    : "None"}
                                </span>
                              </div>
                            </div>
                            <div className=" row">
                              <div className="col-xl-3">
                                <label className="col-lg-12 col-form-label">
                                  {t("Year of Manufacture")}
                                </label>
                              </div>
                              <div className="col-xl-3">
                                <span className="col-lg-8 view-label p">
                                  {rowData.year ? rowData.year : "None"}
                                </span>
                              </div>
                              <div className="col-xl-3">
                                <label className="col-lg-12 col-form-label">
                                  {t("Manufacturer")}
                                </label>
                              </div>
                              <div className="col-xl-3">
                                <span className="col-lg-8 view-label p">
                                  {rowData.manufacturer
                                    ? rowData.manufacturer
                                    : "None"}
                                </span>
                              </div>
                            </div>
                            <div className=" row">
                              <div className="col-xl-3">
                                <label className="col-lg-12 col-form-label">
                                  {t("Model")}
                                </label>
                              </div>
                              <div className="col-xl-3">
                                <span className="col-lg-8 view-label p">
                                  {rowData.model ? rowData.model : "None"}
                                </span>
                              </div>
                              <div className="col-xl-3">
                                <label className="col-lg-12 col-form-label">
                                  {t("Make")}
                                </label>
                              </div>
                              <div className="col-xl-3">
                                <span className="col-lg-8 view-label p">
                                  {rowData.make ? rowData.make : "None"}
                                </span>
                              </div>
                            </div>
                            <div className=" row">
                              <div className="col-xl-3">
                                <label className="col-lg-12 col-form-label ">
                                  {t("Date placed in Service")}
                                </label>
                              </div>
                              <div className="col-xl-3">
                                <span className="col-lg-8 view-label p">
                                  {rowData.date_place
                                    ? Helper.DateNormal(rowData.date_place)
                                    : "None"}
                                </span>
                              </div>
                              <div className="col-xl-3">
                                <label className="col-lg-12 col-form-label">
                                  {t("Life in Months")}
                                </label>
                              </div>
                              <div className="col-xl-3">
                                <span className="col-lg-8 view-label p">
                                  {rowData.life_in_months
                                    ? rowData.life_in_months
                                    : "None"}
                                </span>
                              </div>
                            </div>
                            <div className=" row">
                              <div className="col-xl-3">
                                <label className="col-lg-12 col-form-label">
                                  {t("Net Book Value")}
                                </label>
                              </div>
                              <div className="col-xl-3">
                                <span className="col-lg-8 view-label p">
                                  {rowData.netbookvalue
                                    ? Helper.Amount(rowData.netbookvalue)
                                    : "None"}
                                </span>
                              </div>
                              <div className="col-xl-3">
                                <label className="col-lg-12 col-form-label">
                                  {t("Original Cost")}
                                </label>
                              </div>
                              <div className="col-xl-3">
                                <span className="col-lg-8 view-label p">
                                  {rowData.originalcost
                                    ? Helper.Amount(rowData.originalcost)
                                    : "None"}
                                </span>
                              </div>
                            </div>
                            <div className=" row">
                              <div className="col-xl-3">
                                <label className="col-lg-12 col-form-label">
                                  {t("Contract Number")}
                                </label>
                              </div>
                              <div className="col-xl-3">
                                <span className="col-lg-8 view-label p">
                                  {rowData.contract_number
                                    ? rowData.contract_number
                                    : "None"}
                                </span>
                              </div>
                              <div className="col-xl-3">
                                <label className="col-lg-12 col-form-label">
                                  {t("Item Type")}
                                </label>
                              </div>
                              <div className="col-xl-3">
                                <span className="col-lg-8 view-label p">
                                  {rowData.item_type
                                    ? rowData.item_type
                                    : "None"}
                                </span>
                              </div>
                            </div>
                          </div>
                        </>
                      ),
                    },
                  ]}
                  data={options}
                  options={{
                    selection: false, // Enable row selection
                  }}
                //   onSelectionChange={(rows) => {
                //     if (rows.length > 1) {
                //         rows.pop()
                //     //   setItem_master_id(rows[0].id); // Select the first row
                //     } else {
                //         setItem_master_id(''); // Deselect all
                //     }
                //   }}
                //   selectedRows={item_master_id ? [item_master_id] : []}
                />
              </div>
            </div>
          </SlidingPane>
          <div className="header">
            <h5 className="mb-2 pt-3">{t("Edit Assets")}</h5>
          </div>
          <div className="card" role="document">
            <div className="card-body">
              {asset_type === "Equipment" ? (
                isLoading !== true ? (
                  <Form
                    role="form text-left"
                    onSubmit={handleSubmit(handleRegister)}
                    ref={form}
                    action="."
                    method="POST"
                    id="addPartyContactForm"
                  >
                    {
                      <>
                        <div className="row">
                          <div className="col-xl-4">
                            <div className="form-group row">
                              <label className="col-lg-12 col-form-label required">
                                {t("Asset No")}{" "}
                                <Tooltip content={t("AssetNo_Tooltip")}>
                                  <i class="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <div className="col-lg-12">
                                <input
                                  onChange={(e) =>
                                    setAsset_number(e.target.value)
                                  }
                                  value={asset_number}
                                  type="text"
                                  disabled
                                  name="assetno"
                                  className="form-control"
                                  {...register("assetno", {
                                    onChange: (e) => {
                                      setAsset_number(e.target.value);
                                    },
                                    required: false,
                                  })}
                                />
                                <div className="invalid-feedback">
                                  {errors.assetno?.type === "required" &&
                                    "Asset Number  is required"}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-xl-4">
                            <div className="form-group row">
                              <label className="col-lg-12 col-form-label">
                                {t("Asset Description")}{" "}
                                <Tooltip content={t("AssetDesc_Tooltip")}>
                                  <i class="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              {/* <input
                                                                            value={asset_desc}
                                                                            onChange={(e) => setAsset_desc(e.target.value)}
                                                                            type="text" id="asset_desc" className="form-control" /> */}
                              <div className="col-lg-12 d-flex align-items-center">
                                <div className="flex-grow-1">
                                  <SearchableDropdown
                                    setAsset_desc={setAsset_desc}
                                    asset_desc={asset_desc}
                                    setItem_master_id={setItem_master_id}
                                    contract_id={contractId}
                                    options={options}
                                    setOptions={setOptions}
                                  />
                                </div>
                                <span
                                  onClick={() =>
                                    setState3({ isPaneOpen: true })
                                  }
                                  style={{
                                    color: "#b4b7c5",
                                    paddingLeft: "10px",
                                    cursor: "pointer",
                                  }}
                                >
                                  <img
                                    src={
                                      process.env.PUBLIC_URL +
                                      "/static/images/ic-search.svg"
                                    }
                                    alt="Filter Icon"
                                  />
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="col-xl-4">
                            <div className="form-group row">
                              <label className="col-lg-12 col-form-label">
                                {t("Financed Amount")}{" "}
                                <Tooltip content={t("FinancedAmount_Tooltip")}>
                                  <i class="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <div className="col-lg-12">
                                <input
                                  value={Helper.Amount(financed_amount)}
                                  onChange={(e) =>
                                    setFinanced_amount(e.target.value)
                                  }
                                  type="text"
                                  id="financed_amount"
                                  className="form-control"
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-4">
                            <div className="form-group row">
                              <label className="col-lg-12 col-form-label">
                                {t("Year")}{" "}
                                <Tooltip content={t("Year_Tooltip")}>
                                  <i class="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <div className="col-lg-12">
                                <input
                                  value={year}
                                  onChange={(e) => setYear(e.target.value)}
                                  type="text"
                                  id="year"
                                  className="form-control"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-xl-4">
                            <div className="form-group row">
                              <label className="col-lg-12 col-form-label">
                                {t("Dealer Payable")}{" "}
                                <Tooltip content={t("DealerPayable_Tooltip")}>
                                  <i class="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <div className="col-lg-12">
                                <input
                                  value={Helper.Amount(dealer_payable)}
                                  onChange={(e) =>
                                    setDealer_payable(e.target.value)
                                  }
                                  type="text"
                                  id="dealer_payable"
                                  className="form-control"
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-xl-4">
                            <div className="form-group row">
                              <label className="col-lg-12 col-form-label">
                                {t("Manufacturer")}{" "}
                                <Tooltip content={t("Manufacturer_Tooltip")}>
                                  <i class="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <div className="col-lg-12">
                                <input
                                  value={manufacturer}
                                  onChange={(e) =>
                                    setManufacturer(e.target.value)
                                  }
                                  type="text"
                                  id="manufacturer"
                                  className="form-control"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-4">
                            <div className="form-group row">
                              <label className="col-lg-12 col-form-label">
                                {t("Make")}{" "}
                                <Tooltip content={t("Make_Tooltip")}>
                                  <i class="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <div className="col-lg-12">
                                <input
                                  value={make}
                                  onChange={(e) => setMake(e.target.value)}
                                  type="text"
                                  id="make"
                                  className="form-control"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-xl-4">
                            <div className="form-group row">
                              <label className="col-lg-12 col-form-label">
                                {t("Model")}{" "}
                                <Tooltip content={t("Model_Tooltip")}>
                                  <i class="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <div className="col-lg-12">
                                <input
                                  value={model}
                                  onChange={(e) => setModel(e.target.value)}
                                  type="text"
                                  name="Model"
                                  id="model"
                                  className="form-control"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-xl-4">
                            <div className="form-group row">
                              <label className="col-lg-12 col-form-label">
                                {t("Use Purpose")}{" "}
                                <Tooltip content={t("UsePurpose_Tooltip")}>
                                  <i class="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <div className="col-lg-12">
                                <input
                                  value={user_purpose}
                                  onChange={(e) =>
                                    setUser_purpose(e.target.value)
                                  }
                                  type="text"
                                  name="Use_Purpose"
                                  id="user_purpose"
                                  className="form-control"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-3">
                            <div className="form-group row">
                              <label className="col-lg-12 col-form-label">
                                {t("Asset Type")}{" "}
                                <Tooltip content={t("Assettype_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <div className="col-lg-12">
                                <input
                                  disabled
                                  value={asset_type ? asset_type : ""}
                                  type="text"
                                  name="residal_value"
                                  id="residal_value"
                                  className="form-control"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-xl-3">
                            <div className="form-group row">
                              <label className="col-lg-12 col-form-label">
                                {t("Condition")}{" "}
                                <Tooltip content={t("Condition_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <div className="col-lg-12">
                                <input
                                  value={condition}
                                  onChange={(e) => setCondition(e.target.value)}
                                  type="text"
                                  name="Condition"
                                  //   id="Condition"
                                  className="form-control"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-xl-3">
                            <div className="form-group row">
                              <label className="col-lg-12 col-form-label">
                                {t("VendorAsset ID")}{" "}
                                <Tooltip content={t("VendorAssetID_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <div className="col-lg-12">
                                <input
                                  value={vendor_asset_Id}
                                  onChange={(e) =>
                                    setVendor_Asset_Id(e.target.value)
                                  }
                                  type="text"
                                  name="Condition"
                                  //   id="Condition"
                                  className="form-control"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-xl-3" style={{ display: contract_term === "Loan" ? "none" : true }} >
                            <div className="form-group row">
                              <label className="col-lg-12 col-form-label">
                                {t("Salvage Value")}{" "}
                                <Tooltip content={t("Salvagevalue_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <div className="col-lg-12">
                                <input
                                  value={salvage_value}
                                  onChange={(e) =>
                                    setSalvageValue(e.target.value)
                                  }
                                  type="text"
                                  name="Condition"
                                  //   id="Condition"
                                  className="form-control"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-3">
                            <div className="form-group row">
                              <label className="col-lg-12 col-form-label">{t("Category")}</label>
                              <div className="col-lg-12">
                                <select
                                  className="form-control"
                                  value={selected_category}
                                  onChange={handleCategoryChange}
                                >
                                  <option value="">Select Category</option>
                                  {category_list.map((val, i) => (
                                    <option key={i} value={val.id}>
                                      {val.category_name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="col-xl-3">
                            <div className="form-group row">
                              <label className="col-lg-12 col-form-label">{t("Sub Category")}</label>
                              <div className="col-lg-12">
                                <select
                                  className="form-control"
                                  value={selected_sub_category}
                                  onChange={handlesubCategoryChange}
                                >
                                  <option value="">Select Subcategory</option>
                                  {sub_categories.map((val, i) => (
                                    <option key={i} value={val.id}>
                                      {val.sub_category_name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-3">
                            <div className="form-group row">
                              <label className="col-lg-12 col-form-label required">
                                {t("Quantity")} <Tooltip content={t("Quantity_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip>
                              </label>
                              <div className="col-lg-12">
                                <input
                                  value={quantity}
                                  onChange={handleQuantityChange}
                                  type="number"
                                  min="1"
                                  name="quantity"
                                  id="quantity"
                                  className="form-control"
                                />
                                {quantityError && (
                                  <div className="invalid-feedback">{quantityError}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="table-responsive">
                          <table className="table table-nowrap mb-0" style={{ maxWidth: "300px" }}>
                            <thead>
                              <tr>
                                <th style={{ color: "#245C7F" }}>{t("Serial Number")} <Tooltip content={t("SerialNumber_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></th>
                              </tr>
                            </thead>
                            <tbody>
                              {serialRows.map((row, index) => (
                                <tr key={index}>
                                  <td>
                                    <input
                                      value={row.serial_number}
                                      onChange={(e) =>
                                        handleSerialNumberChange(index, e.target.value)
                                      }
                                      type="text"
                                      className="form-control"
                                    />
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                        <div
                          className="row"
                          style={{
                            display: contract_term === "Loan" ? "none" : true,
                          }}
                        >
                          <div className="col-xl-12">
                            <div className="form-group row">
                              <label className="col-lg-12 col-form-label">
                                {t("Residual Value")}{" "}
                                <Tooltip content={t("ResidalValue_Tooltip")}>
                                  <i class="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <div className="col-lg-12">
                                <CurrencyInput
                                  id="input-example"
                                  name="input-name"
                                  allowDecimals={false}
                                  value={residal_value}
                                  onValueChange={(value) => {
                                    if (value === undefined || value === "") {
                                      seTresidal_value("");
                                      return;
                                    }
                                    const num = Number(value);
                                    if (!isNaN(num) && num >= 0) {
                                      seTresidal_value(value);
                                    }
                                  }}
                                  className="form-control"
                                  disableAbbreviations
                                  min={0}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <h4 className="card-title">
                          {t("Install Address")}
                        </h4>
                        <div className="row">
                          <div className="col-xl-12">
                            <div className="form-group row">
                              <label className="col-lg-12 col-form-label required">
                                {t("Address")}{" "}
                                <Tooltip content={t("InstallAddress_Tooltip")}>
                                  <i class="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <div className="col-lg-11">
                                {/* <select
                                                                            className="form-control input-lg"
                                                                            value={reg_address}
                                                                            name="address_id"
                                                                            id="address_list"
                                                                            title="Select Address"
                                                                            {...register("address_id", { onChange: (e) => { setReg_address(e.target.value) }, required: true })}
                                                                        >
                                                                            <option value="" >---{t("Select Install Address")}---</option>
                                                                            {
                                                                                reg_address1.map((key) => (
                                                                                    <option key={key.id} value={key.id}>{key.address_line_1}, {key.address_line_2 !== "" ? `${key.address_line_2},` : ""} {key.city}, {key.state}, {key.country}</option>

                                                                                ))
                                                                            }
                                                                        </select> */}
                                <AsyncSelect
                                  {...register("address_id", {
                                    required: true,
                                  })}
                                  name="address_id"
                                  cacheOptions
                                  defaultOptions={filteredOptions}
                                  isClearable
                                  isSearchable
                                  options={filteredOptions}
                                  getOptionLabel={(option) => option.label}
                                  getOptionValue={(option) => option.value}
                                  onChange={handleAddressChange}
                                  loadOptions={loadOptionInstallAdd}
                                  value={filteredOptions.find(
                                    (val) => val.value === reg_address
                                  )}
                                  placeholder={`${t("Search Install Address")}`}
                                />
                                <div className="invalid-feedback">
                                  {(errors.address_id?.type === "required" &&
                                    "Address  is required") ||
                                    reg_address === null
                                    ? "Address  is required"
                                    : ""}
                                </div>
                              </div>
                              <div className="col-lg-1">
                                <img
                                  onClick={() =>
                                    setState2({ isPaneOpen: true })
                                  }
                                  className=""
                                  style={{
                                    height: "20px",
                                    cursor: "pointer",
                                    marginLeft: "5px",
                                  }}
                                  src={
                                    process.env.PUBLIC_URL +
                                    "/static/images/iconplus.png"
                                  }
                                  alt="ADD"
                                ></img>
                              </div>
                            </div>
                          </div>
                        </div>
                        <h4 className="card-title">{t("Supplier Details")}</h4>
                        <div className="row">
                          <div className="col-xl-4">
                            <div className="form-group row">
                              <label className="col-lg-12 col-form-label required">
                                {t("Vendor Name")}{" "}
                                <Tooltip content={t("VendorName_Tooltip")}>
                                  <i class="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <div className="col-lg-10">
                                {/* <select
                                                                            className="form-control input-lg"
                                                                            value={vendor_name}
                                                                            name="vendorname1"
                                                                            id="vendor_list"
                                                                            {...register("vendorname1", { onChange: (e) => { setVendor_name(e.target.value) }, required: true })}
                                                                        >
                                                                            <option value="">---{t("Select Vendor Name")}---</option>
                                                                            {
                                                                                vendorname.map((key1) => (
                                                                                    <option key={key1.id} value={key1.id}>{key1.customer_name}</option>
                                                                                ))
                                                                            }
                                                                        </select> */}
                                <AsyncSelect
                                  {...register("vendorname1", {
                                    required: true,
                                  })}
                                  name="vendorname1"
                                  cacheOptions
                                  defaultOptions={filteredVendor}
                                  isClearable
                                  isSearchable
                                  options={filteredVendor}
                                  getOptionLabel={(option) => option.label}
                                  getOptionValue={(option) => option.value}
                                  onChange={handleVendorChange}
                                  loadOptions={loadOptionVendorName}
                                  value={filteredVendor.find(
                                    (val) => val.value === vendor_name
                                  )}
                                  placeholder={`${t("Search Vendor Name")}`}
                                />
                                <div className="invalid-feedback">
                                  {errors.vendorname1 && "Vendor is required"}
                                </div>
                              </div>
                              <div className="col-lg-2">
                                <img
                                  onClick={() => setState({ isPaneOpen: true })}
                                  className=""
                                  style={{
                                    height: "20px",
                                    cursor: "pointer",
                                    marginLeft: "-5px",
                                  }}
                                  src={
                                    process.env.PUBLIC_URL +
                                    "/static/images/iconplus.png"
                                  }
                                  alt="ADD"
                                ></img>
                              </div>
                            </div>
                          </div>
                          <div className="col-xl-4">
                            <div className="form-group row">
                              <label className="col-lg-12 col-form-label">
                                {t("Delivery Date")}{" "}
                                <Tooltip content={t("DeliveryDate_Tooltip")}>
                                  <i class="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <div className="col-lg-12">
                                <DatePicker
                                  className="form-control datepick"
                                  selected={
                                    delivery_date ? new Date(delivery_date) : ""
                                  }
                                  onChange={(e) => setDelivery_date(e)}
                                  placeholderText={"mm/dd/yyyy"}
                                  showMonthDropdown
                                  showYearDropdown // year show and scrolldown alos
                                  scrollableYearDropdown
                                  dropdownMode="select"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-xl-4">
                            <div className="form-group row">
                              <label className="col-lg-12 col-form-label">
                                {t("In-Service Date")}{" "}
                                <Tooltip content={t("In-ServiceDate_Tooltip")}>
                                  <i class="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <div className="col-lg-12">
                                <DatePicker
                                  className="form-control datepick"
                                  selected={
                                    in_service_date
                                      ? new Date(in_service_date)
                                      : ""
                                  }
                                  onChange={(e) => setIn_service_date(e)}
                                  placeholderText={"mm/dd/yyyy"}
                                  showYearDropdown // year show and scrolldown alos
                                  scrollableYearDropdown
                                  showMonthDropdown
                                  dropdownMode="select"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-4">
                            <div className="form-group row">
                              <label className="col-lg-12 col-form-label">
                                {t("Equipment Cost")}{" "}
                                <Tooltip content={t("VehicleCost_Tooltip")}>
                                  <i class="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <div className="col-lg-6">
                                <CurrencyInput
                                  className="form-control"
                                  id="input-example"
                                  {...register("vehiclecost", {
                                    validate: {
                                      positive: (v) =>
                                        parseInt(v) > 0 ||
                                        "Asset cost is required",
                                    },
                                  })}
                                  allowDecimals="false"
                                  value={vehicle_cost}
                                  onValueChange={(value) =>
                                    setVehicle_cost(value)
                                  }
                                  name="vehiclecost"
                                  disableAbbreviations
                                />
                                <div className="invalid-feedback">
                                  {errors.vehiclecost?.type === "positive" &&
                                    "Asset cost is required"}
                                </div>
                              </div>
                              <div
                                style={{ padding: "0" }}
                                className="col-lg-6"
                              >
                                <select
                                  value={vehicle_cost_payto}
                                  onChange={(e) =>
                                    setVehicle_cost_payto(e.target.value)
                                  }
                                  id="vehicle_cost_payto"
                                  className="form-control"
                                >
                                  <option value="">{t("Select")}</option>
                                  <option value="Borrower">
                                    {t("Borrower")}
                                  </option>
                                  <option value="Dealer">{t("Dealer")}</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="col-xl-4">
                            <div className="form-group row">
                              <label className="col-lg-12 col-form-label">
                                {t("Tax (%)")}{" "}
                                <Tooltip content={t("Tax_Tooltip")}>
                                  <i class="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <div className="col-lg-6">
                                <CurrencyInput
                                  id="input-example"
                                  name="input-name"
                                  allowDecimals="false"
                                  value={tax_amount}
                                  onValueChange={(value) =>
                                    setTax_amount(value)
                                  }
                                  className="form-control"
                                  disableAbbreviations
                                />
                              </div>
                              <div
                                style={{ padding: "0px 15px 0px 0px" }}
                                className="col-lg-6"
                              >
                                <select
                                  value={tax_amount_payto}
                                  onChange={(e) =>
                                    setTax_amount_payto(e.target.value)
                                  }
                                  id="tax_amount_payto"
                                  className="form-control"
                                >
                                  <option value="">{t("Select")}</option>
                                  <option value="Borrower">
                                    {t("Borrower")}
                                  </option>
                                  <option value="Dealer">{t("Dealer")}</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="col-xl-4">
                            <div className="form-group row">
                              <label className="col-lg-12 col-form-label">
                                {t("Trade In")}{" "}
                                <Tooltip content={t("TradeIn_Tooltip")}>
                                  <i class="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <div className="col-lg-6">
                                <CurrencyInput
                                  id="input-example"
                                  name="input-name"
                                  allowDecimals="false"
                                  value={trade_in}
                                  onValueChange={(value) => setTrade_in(value)}
                                  className="form-control"
                                  disableAbbreviations
                                />
                              </div>
                              <div className="col-lg-6">
                                <select
                                  value={trade_in_payto}
                                  onChange={(e) =>
                                    setTrade_in_payto(e.target.value)
                                  }
                                  id="trade_in_payto"
                                  className="form-control"
                                >
                                  <option value="">{t("Select")}</option>
                                  <option value="Borrower">
                                    {t("Borrower")}
                                  </option>
                                  <option value="Dealer">{t("Dealer")}</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-4">
                            <div className="form-group row">
                              <label className="col-lg-12  col-form-label">
                                {t("Total Cost")}{" "}
                                <Tooltip content={t("TotalCost_Tooltip")}>
                                  <i class="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <div className="col-lg-12">
                                <input
                                  value={Helper.Amount(total_cost)}
                                  onChange={(e) =>
                                    setTotal_cost(e.target.value)
                                  }
                                  type="text"
                                  name="total_cost"
                                  id="total_cost"
                                  className="form-control"
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-xl-4">
                            <div className="form-group row">
                              <label className="col-lg-12 col-form-label">
                                {t("Down Payment")}{" "}
                                <Tooltip content={t("DownPayment_Tooltip")}>
                                  <i class="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <div className="col-lg-6">
                                <CurrencyInput
                                  id="input-example"
                                  name="input-name"
                                  allowDecimals="false"
                                  value={down_payment}
                                  onValueChange={(value) =>
                                    setDown_payment(value)
                                  }
                                  className="form-control"
                                  disableAbbreviations
                                />
                              </div>
                              <div className="col-lg-6">
                                <select
                                  value={down_payment_payto}
                                  onChange={(e) =>
                                    setDown_payment_payto(e.target.value)
                                  }
                                  id="down_payment_payto"
                                  className="form-control"
                                >
                                  <option value="">{t("Select")}</option>
                                  <option value="Borrower">
                                    {t("Borrower")}
                                  </option>
                                  <option value="Dealer">{t("Dealer")}</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                        {extrafiledcontractasset.length === 0 ? (
                          ""
                        ) : (
                          <h4 className="tc mt-4">
                            {t("Additional Information")} :
                          </h4>
                        )}
                        <div className="form-group row">
                          {extrafiledcontractasset.map((key, index) => (
                            <div
                              className={
                                key.enable === "True" ? "col-sm-6" : null
                              }
                            >
                              <>
                                <label
                                  style={{
                                    display:
                                      key.enable === "True" ? true : "none",
                                  }}
                                  className="col-form-label"
                                >
                                  {" "}
                                  {key.label}{" "}
                                  <Tooltip content={key.label}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </label>
                                <input
                                  style={{
                                    display:
                                      key.enable === "True" ? true : "none",
                                  }}
                                  id={"attribute_" + index}
                                  value={
                                    attribute[index]["attribute"]
                                      ? attribute[index]["attribute"]
                                      : ""
                                  }
                                  className="form-control mb-1"
                                  name="attribute"
                                  type={key.datatype}
                                  placeholder={key.label}
                                  onChange={(e) =>
                                    onChangeextrafileds(e, index)
                                  }
                                />
                              </>
                            </div>
                          ))}
                        </div>
                        <div className="text-left py-3">
                          <input type="hidden" id="assetId" />
                          <button
                            type="button"
                            className="asset-cancel btn btn-secondary btn-md"
                            onClick={handleCancel}
                          >
                            {t("Cancel")}
                          </button>
                          &nbsp;
                          <button
                            type="button"
                            className="btn-assets border-0 btn btn-primary btn-gradient-primary btn-md"
                            onClick={handleSave}
                          >
                            {t("Save and continue editing ")}
                          </button>
                          &nbsp;
                          <button
                            type="submit"
                            disabled={disablebutton}
                            className="btn-assets border-0 btn btn-primary btn-gradient-primary btn-md"
                          >
                            {loading === false ? (
                              t("Update")
                            ) : (
                              <ButtonLoading />
                            )}
                          </button>
                          &nbsp;
                        </div>
                      </>
                    }
                    <CheckButton style={{ display: "none" }} ref={checkBtn} />
                  </Form>
                ) : (
                  <ContentLoader
                    viewBox="0 0 1000 550"
                    backgroundColor="rgba(0,0,0,0.06)"
                    foregroundColor="rgba(0,0,0,0.12)"
                  >
                    <rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
                    <circle cx="879" cy="123" r="11" />
                    <circle cx="914" cy="123" r="11" />
                    <rect
                      x="104"
                      y="115"
                      rx="3"
                      ry="3"
                      width="141"
                      height="15"
                    />
                    <rect
                      x="305"
                      y="114"
                      rx="3"
                      ry="3"
                      width="299"
                      height="15"
                    />
                    <rect
                      x="661"
                      y="114"
                      rx="3"
                      ry="3"
                      width="141"
                      height="15"
                    />
                    <rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
                    <circle cx="880" cy="184" r="11" />
                    <circle cx="915" cy="184" r="11" />
                    <rect
                      x="105"
                      y="176"
                      rx="3"
                      ry="3"
                      width="141"
                      height="15"
                    />
                    <rect
                      x="306"
                      y="175"
                      rx="3"
                      ry="3"
                      width="299"
                      height="15"
                    />
                    <rect
                      x="662"
                      y="175"
                      rx="3"
                      ry="3"
                      width="141"
                      height="15"
                    />
                    <rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
                    <circle cx="881" cy="242" r="11" />
                    <circle cx="916" cy="242" r="11" />
                    <rect
                      x="106"
                      y="234"
                      rx="3"
                      ry="3"
                      width="141"
                      height="15"
                    />
                    <rect
                      x="307"
                      y="233"
                      rx="3"
                      ry="3"
                      width="299"
                      height="15"
                    />
                    <rect
                      x="663"
                      y="233"
                      rx="3"
                      ry="3"
                      width="141"
                      height="15"
                    />
                    <rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
                    <circle cx="882" cy="303" r="11" />
                    <circle cx="917" cy="303" r="11" />
                    <rect
                      x="107"
                      y="295"
                      rx="3"
                      ry="3"
                      width="141"
                      height="15"
                    />
                    <rect
                      x="308"
                      y="294"
                      rx="3"
                      ry="3"
                      width="299"
                      height="15"
                    />
                    <rect
                      x="664"
                      y="294"
                      rx="3"
                      ry="3"
                      width="141"
                      height="15"
                    />
                    <rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
                    <circle cx="881" cy="363" r="11" />
                    <circle cx="916" cy="363" r="11" />
                    <rect
                      x="106"
                      y="355"
                      rx="3"
                      ry="3"
                      width="141"
                      height="15"
                    />
                    <rect
                      x="307"
                      y="354"
                      rx="3"
                      ry="3"
                      width="299"
                      height="15"
                    />
                    <rect
                      x="663"
                      y="354"
                      rx="3"
                      ry="3"
                      width="141"
                      height="15"
                    />
                    <rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
                    <circle cx="882" cy="424" r="11" />
                    <circle cx="917" cy="424" r="11" />
                    <rect
                      x="107"
                      y="416"
                      rx="3"
                      ry="3"
                      width="141"
                      height="15"
                    />
                    <rect
                      x="308"
                      y="415"
                      rx="3"
                      ry="3"
                      width="299"
                      height="15"
                    />
                    <rect
                      x="664"
                      y="415"
                      rx="3"
                      ry="3"
                      width="141"
                      height="15"
                    />
                    <rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
                    <rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
                    <rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
                    <circle cx="882" cy="484" r="11" />
                    <circle cx="917" cy="484" r="11" />
                    <rect
                      x="107"
                      y="476"
                      rx="3"
                      ry="3"
                      width="141"
                      height="15"
                    />
                    <rect
                      x="308"
                      y="475"
                      rx="3"
                      ry="3"
                      width="299"
                      height="15"
                    />
                    <rect
                      x="664"
                      y="475"
                      rx="3"
                      ry="3"
                      width="141"
                      height="15"
                    />
                    <rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
                    <rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
                    <rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
                    <rect
                      x="222"
                      y="54"
                      rx="3"
                      ry="3"
                      width="149"
                      height="33"
                    />
                    <rect
                      x="544"
                      y="55"
                      rx="3"
                      ry="3"
                      width="137"
                      height="33"
                    />
                    <rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
                    <rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
                  </ContentLoader>
                )
              ) : isLoading !== true ? (
                <Form
                  role="form text-left"
                  onSubmit={handleSubmit(handleRegister)}
                  ref={form}
                  action="."
                  method="POST"
                  id="addPartyContactForm"
                >
                  {
                    <>
                      <div className="row">
                        <div className="col-xl-3">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label required">
                              {t("Asset No")}{" "}
                              <Tooltip content={t("AssetNo_Tooltip")}>
                                <i class="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-lg-12">
                              <input
                                onChange={(e) =>
                                  setAsset_number(e.target.value)
                                }
                                value={asset_number}
                                type="text"
                                disabled
                                name="assetno"
                                className="form-control"
                                {...register("assetno", {
                                  onChange: (e) => {
                                    setAsset_number(e.target.value);
                                  },
                                  required: false,
                                })}
                              />
                              <div className="invalid-feedback">
                                {errors.assetno?.type === "required" &&
                                  "Asset Number  is required"}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-3">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label">
                              {t("Asset Description")}{" "}
                              <Tooltip content={t("AssetDesc_Tooltip")}>
                                <i class="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-lg-12">
                              {/* <input
                                                                            value={asset_desc}
                                                                            onChange={(e) => setAsset_desc(e.target.value)}
                                                                            type="text" id="asset_desc" className="form-control" /> */}
                              <div className="col-lg-12 d-flex align-items-center">
                                <div className="flex-grow-1">
                                  <SearchableDropdown
                                    setAsset_desc={setAsset_desc}
                                    asset_desc={asset_desc}
                                    setItem_master_id={setItem_master_id}
                                    contract_id={contractId}
                                    options={options}
                                    setOptions={setOptions}
                                  />
                                </div>
                                <span
                                  onClick={() =>
                                    setState3({ isPaneOpen: true })
                                  }
                                  style={{
                                    color: "#b4b7c5",
                                    paddingLeft: "10px",
                                    cursor: "pointer",
                                  }}
                                >
                                  <img
                                    src={
                                      process.env.PUBLIC_URL +
                                      "/static/images/ic-search.svg"
                                    }
                                    alt="Filter Icon"
                                  />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-3">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label">
                              {t("License No")}{" "}
                              <Tooltip content={t("LicenseNo_Tooltip")}>
                                <i class="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-lg-12">
                              <input
                                value={license_number}
                                onChange={(e) =>
                                  setLicense_number(e.target.value)
                                }
                                type="text"
                                name="license_number"
                                id="license_number"
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-3">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label">
                              {t("Financed Amount")}{" "}
                              <Tooltip content={t("FinancedAmount_Tooltip")}>
                                <i class="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-lg-12">
                              <input
                                value={Helper.Amount(financed_amount)}
                                onChange={(e) =>
                                  setFinanced_amount(e.target.value)
                                }
                                type="text"
                                id="financed_amount"
                                className="form-control"
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-xl-3" style={{ display: "none" }}>
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label">
                              {t("VIN Number")}{" "}
                              <Tooltip content={t("VINNumber_Tooltip")}>
                                <i class="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-lg-12">
                              <input
                                value={vin_number}
                                onBlur={handlevin}
                                onChange={(e) => setVin_number(e.target.value)}
                                type="text"
                                id="vin_number"
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-3">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label">
                              {t("Year")}{" "}
                              <Tooltip content={t("Year_Tooltip")}>
                                <i class="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-lg-12">
                              <input
                                value={year}
                                onChange={(e) => setYear(e.target.value)}
                                type="text"
                                id="year"
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-3">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label">
                              {t("License State")}{" "}
                              <Tooltip content={t("LicenseState_Tooltip")}>
                                <i class="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-lg-12">
                              <input
                                value={license_state}
                                onChange={(e) =>
                                  setLicense_state(e.target.value)
                                }
                                type="text"
                                name="license_state"
                                id="license_state"
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-3">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label">
                              {t("Dealer Payable")}{" "}
                              <Tooltip content={t("DealerPayable_Tooltip")}>
                                <i class="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-lg-12">
                              <input
                                value={Helper.Amount(dealer_payable)}
                                onChange={(e) =>
                                  setDealer_payable(e.target.value)
                                }
                                type="text"
                                id="dealer_payable"
                                className="form-control"
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-xl-3">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label">
                              {t("Manufacturer")}{" "}
                              <Tooltip content={t("Manufacturer_Tooltip")}>
                                <i class="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-lg-12">
                              <input
                                value={manufacturer}
                                onChange={(e) =>
                                  setManufacturer(e.target.value)
                                }
                                type="text"
                                id="manufacturer"
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-3">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label">
                              {t("Make")}{" "}
                              <Tooltip content={t("Make_Tooltip")}>
                                <i class="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-lg-12">
                              <input
                                value={make}
                                onChange={(e) => setMake(e.target.value)}
                                type="text"
                                id="make"
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-3">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label">
                              {t("Model")}{" "}
                              <Tooltip content={t("Model_Tooltip")}>
                                <i class="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-lg-12">
                              <input
                                value={model}
                                onChange={(e) => setModel(e.target.value)}
                                type="text"
                                name="Model"
                                id="model"
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-3">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label">
                              {t("Use Purpose")}{" "}
                              <Tooltip content={t("UsePurpose_Tooltip")}>
                                <i class="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-lg-12">
                              <input
                                value={user_purpose}
                                onChange={(e) =>
                                  setUser_purpose(e.target.value)
                                }
                                type="text"
                                name="Use_Purpose"
                                id="user_purpose"
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-xl-3">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label">
                              {t("Asset Type")}{" "}
                              <Tooltip content={t("Assettype_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-lg-12">
                              <input
                                disabled
                                value={asset_type ? asset_type : ""}
                                type="text"
                                name="residal_value"
                                id="residal_value"
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-3">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label">
                              {t("Condition")}{" "}
                              <Tooltip content={t("Condition_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-lg-12">
                              <input
                                value={condition}
                                onChange={(e) => setCondition(e.target.value)}
                                type="text"
                                name="Condition"
                                // id="Condition"
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-3">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label">
                              {t("VendorAsset ID")}{" "}
                              <Tooltip content={t("VendorAssetID_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-lg-12">
                              <input
                                value={vendor_asset_Id}
                                onChange={(e) =>
                                  setVendor_Asset_Id(e.target.value)
                                }
                                type="text"
                                name="Condition"
                                // id="Condition"
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label">
                              Attachments
                            </label>

                            <div className="col-lg-12">
                              <input
                                type="file"
                                className="form-control"
                                onChange={(e) => setAttachment(e.target.files[0])}
                              />
                              {/* Selected file */}
                              {attachment && (
                                <div className="mt-1 text-muted">
                                  Selected: {attachment.name}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-3" style={{ display: contract_term === "Loan" ? "none" : true }} >
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label">
                              {t("Salvage Value")}{" "}
                              <Tooltip content={t("Salvagevalue_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-lg-12">
                              <input
                                value={salvage_value}
                                onChange={(e) =>
                                  setSalvageValue(e.target.value)
                                }
                                type="text"
                                name="Condition"
                                // id="Condition"
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-xl-3">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label">{t("Category")}</label>
                            <div className="col-lg-12">
                              <select
                                className="form-control"
                                value={selected_category}
                                onChange={handleCategoryChange}
                              >
                                <option value="">Select Category</option>
                                {category_list.map((val, i) => (
                                  <option key={i} value={val.id}>
                                    {val.category_name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-3">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label">{t("Sub Category")}</label>
                            <div className="col-lg-12">
                              <select
                                className="form-control"
                                value={selected_sub_category}
                                onChange={handlesubCategoryChange}
                              >
                                <option value="">Select Subcategory</option>
                                {sub_categories.map((val, i) => (
                                  <option key={i} value={val.id}>
                                    {val.sub_category_name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-xl-3">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label required">
                              {t("Quantity")} <Tooltip content={t("Quantity_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip>
                            </label>
                            <div className="col-lg-12">
                              <input
                                value={quantity}
                                onChange={handleQuantityChange}
                                type="number"
                                min="1"
                                name="quantity"
                                id="quantity"
                                className="form-control"
                              />
                              {quantityError && (
                                <div className="invalid-feedback">{quantityError}</div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="table-responsive">
                        <table className="table table-nowrap mb-0" style={{ maxWidth: "300px" }}>
                          <thead>
                            <tr>
                              <th className="required" style={{ color: "#245C7F" }}>{t("VIN Number")} <Tooltip content={t("VINNumber_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></th>
                            </tr>
                          </thead>
                          <tbody>
                            {serialRows.map((row, index) => (
                              <tr key={index}>
                                <td>
                                  <input
                                    value={row.serial_number}
                                    onChange={(e) =>
                                      handleSerialNumberChange(index, e.target.value)
                                    }
                                    type="text"
                                    className="form-control"
                                  />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div
                        className="row"
                        style={{
                          display: contract_term === "Loan" ? "none" : true,
                        }}
                      >
                        <div className="col-xl-12">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label">
                              {t("Residual Value")}{" "}
                              <Tooltip content={t("ResidalValue_Tooltip")}>
                                <i class="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-lg-12">
                              <CurrencyInput
                                id="input-example"
                                name="input-name"
                                allowDecimals="false"
                                value={residal_value}
                                onValueChange={(value) =>
                                  seTresidal_value(value)
                                }
                                className="form-control"
                                disableAbbreviations
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <h4 className="card-title">{t("Install Address")}</h4>
                      <div className="row">
                        <div className="col-xl-12">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label required">
                              {t("Address")}{" "}
                              <Tooltip content={t("InstallAddress_Tooltip")}>
                                <i class="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-lg-11">
                              {/* <select
                                                                        className="form-control input-lg"
                                                                        value={reg_address}
                                                                        name="address_id"
                                                                        id="address_list"
                                                                        title="Select Address"
                                                                        {...register("address_id", { onChange: (e) => { setReg_address(e.target.value) }, required: true })}
                                                                    >
                                                                        <option value="" >---{t("Select Install Address")}---</option>
                                                                        {
                                                                            reg_address1.map((key) => (
                                                                                <option key={key.id} value={key.id}>{key.address_line_1}, {key.address_line_2 !== "" ? `${key.address_line_2},` : ""} {key.city}, {key.state}, {key.country}</option>

                                                                            ))
                                                                        }
                                                                    </select> */}
                              <AsyncSelect
                                {...register("address_id", {
                                  required: true,
                                })}
                                name="address_id"
                                cacheOptions
                                defaultOptions={filteredOptions}
                                isClearable
                                isSearchable
                                options={filteredOptions}
                                getOptionLabel={(option) => option.label}
                                getOptionValue={(option) => option.value}
                                onChange={handleAddressChange}
                                loadOptions={loadOptionInstallAdd}
                                value={filteredOptions.find(
                                  (val) => val.value === reg_address
                                )}
                                placeholder={`${t("Search Install Address")}`}
                              />
                              <div className="invalid-feedback">
                                {(errors.address_id?.type === "required" &&
                                  "Address  is required") ||
                                  reg_address === null
                                  ? "Address  is required"
                                  : ""}
                              </div>
                            </div>
                            <div className="col-lg-1">
                              <img
                                onClick={() => setState2({ isPaneOpen: true })}
                                className=""
                                style={{
                                  height: "20px",
                                  cursor: "pointer",
                                  marginLeft: "5px",
                                }}
                                src={
                                  process.env.PUBLIC_URL +
                                  "/static/images/iconplus.png"
                                }
                                alt="ADD"
                              ></img>
                            </div>
                          </div>
                        </div>
                      </div>
                      <h4 className="card-title">{t("Supplier Details")}</h4>
                      <div className="row">
                        <div className="col-xl-3">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label required">
                              {t("Vendor Name")}{" "}
                              <Tooltip content={t("VendorName_Tooltip")}>
                                <i class="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-lg-10">
                              {/* <select
                                                                            className="form-control input-lg"
                                                                            value={vendor_name}
                                                                            name="vendorname1"
                                                                            id="vendor_list"
                                                                            {...register("vendorname1", { onChange: (e) => { setVendor_name(e.target.value) }, required: true })}
                                                                        >
                                                                            <option value="">---{t("Select Vendor Name")}---</option>
                                                                            {
                                                                                vendorname.map((key1) => (
                                                                                    <option key={key1.id} value={key1.id}>{key1.customer_name}</option>
                                                                                ))
                                                                            }
                                                                        </select> */}
                              <AsyncSelect
                                {...register("vendorname1", {
                                  required: true,
                                })}
                                name="vendorname1"
                                cacheOptions
                                defaultOptions={filteredVendor}
                                isClearable
                                isSearchable
                                options={filteredVendor}
                                getOptionLabel={(option) => option.label}
                                getOptionValue={(option) => option.value}
                                onChange={handleVendorChange}
                                loadOptions={loadOptionVendorName}
                                value={filteredVendor.find(
                                  (val) => val.value === vendor_name
                                )}
                                placeholder={`${t("Search Vendor Name")}`}
                              />
                              <div className="invalid-feedback">
                                {errors.vendorname1 && "Vendor is required"}
                              </div>
                            </div>
                            <div className="col-lg-2">
                              <img
                                onClick={() => setState({ isPaneOpen: true })}
                                className=""
                                style={{
                                  height: "20px",
                                  cursor: "pointer",
                                  marginLeft: "-5px",
                                }}
                                src={
                                  process.env.PUBLIC_URL +
                                  "/static/images/iconplus.png"
                                }
                                alt="ADD"
                              ></img>
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-3">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label">
                              {t("Delivery Date")}{" "}
                              <Tooltip content={t("DeliveryDate_Tooltip")}>
                                <i class="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-lg-12">
                              <DatePicker
                                className="form-control datepick"
                                selected={
                                  delivery_date ? new Date(delivery_date) : ""
                                }
                                onChange={(e) => setDelivery_date(e)}
                                placeholderText={"mm/dd/yyyy"}
                                showMonthDropdown
                                showYearDropdown // year show and scrolldown alos
                                scrollableYearDropdown
                                dropdownMode="select"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-3">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label">
                              {t("In-Service Date")}{" "}
                              <Tooltip content={t("In-ServiceDate_Tooltip")}>
                                <i class="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-lg-12">
                              <DatePicker
                                className="form-control datepick"
                                selected={
                                  in_service_date
                                    ? new Date(in_service_date)
                                    : ""
                                }
                                onChange={(e) => setIn_service_date(e)}
                                placeholderText={"mm/dd/yyyy"}
                                showYearDropdown // year show and scrolldown alos
                                scrollableYearDropdown
                                showMonthDropdown
                                dropdownMode="select"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-3">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label">
                              {t("Mileage")}{" "}
                              <Tooltip content={t("Mileage_Tooltip")}>
                                <i class="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-lg-12">
                              <CurrencyInput
                                className="form-control"
                                id="input-example"
                                name="input-name"
                                allowDecimals="false"
                                value={milage}
                                onValueChange={(value) => setMilage(value)}
                                disableAbbreviations
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-xl-4">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label">
                              {t("Vehicle Cost")}{" "}
                              <Tooltip content={t("VehicleCost_Tooltip")}>
                                <i class="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-lg-6">
                              <CurrencyInput
                                className="form-control"
                                id="input-example"
                                {...register("vehiclecost", {
                                  validate: {
                                    positive: (v) =>
                                      parseInt(v) > 0 ||
                                      "Asset cost is required",
                                  },
                                })}
                                allowDecimals="false"
                                value={vehicle_cost}
                                onValueChange={(value) =>
                                  setVehicle_cost(value)
                                }
                                name="vehiclecost"
                                disableAbbreviations
                              />
                              <div className="invalid-feedback">
                                {errors.vehiclecost?.type === "positive" &&
                                  "Asset cost is required"}
                              </div>
                            </div>
                            <div style={{ padding: "0" }} className="col-lg-6">
                              <select
                                value={vehicle_cost_payto}
                                onChange={(e) =>
                                  setVehicle_cost_payto(e.target.value)
                                }
                                id="vehicle_cost_payto"
                                className="form-control"
                              >
                                <option value="">{t("Select")}</option>
                                <option value="Borrower">
                                  {t("Borrower")}
                                </option>
                                <option value="Dealer">{t("Dealer")}</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-4">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label">
                              {t("Tax (%)")}{" "}
                              <Tooltip content={t("Tax_Tooltip")}>
                                <i class="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-lg-6">
                              <CurrencyInput
                                id="input-example"
                                name="input-name"
                                allowDecimals="false"
                                value={tax_amount}
                                onValueChange={(value) => setTax_amount(value)}
                                className="form-control"
                                disableAbbreviations
                              />
                            </div>
                            <div
                              style={{ padding: "0px 15px 0px 0px" }}
                              className="col-lg-6"
                            >
                              <select
                                value={tax_amount_payto}
                                onChange={(e) =>
                                  setTax_amount_payto(e.target.value)
                                }
                                id="tax_amount_payto"
                                className="form-control"
                              >
                                <option value="">{t("Select")}</option>
                                <option value="Borrower">
                                  {t("Borrower")}
                                </option>
                                <option value="Dealer">{t("Dealer")}</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-4">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label">
                              {t("Trade In")}{" "}
                              <Tooltip content={t("TradeIn_Tooltip")}>
                                <i class="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-lg-6">
                              <CurrencyInput
                                id="input-example"
                                name="input-name"
                                allowDecimals="false"
                                value={trade_in}
                                onValueChange={(value) => setTrade_in(value)}
                                className="form-control"
                                disableAbbreviations
                              />
                            </div>
                            <div className="col-lg-6">
                              <select
                                value={trade_in_payto}
                                onChange={(e) =>
                                  setTrade_in_payto(e.target.value)
                                }
                                id="trade_in_payto"
                                className="form-control"
                              >
                                <option value="">{t("Select")}</option>
                                <option value="Borrower">
                                  {t("Borrower")}
                                </option>
                                <option value="Dealer">{t("Dealer")}</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-xl-4">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label">
                              {t("Registration")}{" "}
                              <Tooltip content={t("Registration_Tooltip")}>
                                <i class="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-lg-6">
                              <CurrencyInput
                                id="input-example"
                                name="input-name"
                                allowDecimals="false"
                                value={reg_cost}
                                onValueChange={(value) => setReg_cost(value)}
                                className="form-control"
                                disableAbbreviations
                              />
                            </div>
                            <div style={{ padding: "0" }} className="col-lg-6">
                              <select
                                value={reg_cost_payto}
                                onChange={(e) =>
                                  setReg_cost_payto(e.target.value)
                                }
                                id="reg_cost_payto"
                                className="form-control"
                              >
                                <option value="">{t("Select")}</option>
                                <option value="Borrower">
                                  {t("Borrower")}
                                </option>
                                <option value="Dealer">{t("Dealer")}</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-4">
                          <div className="form-group row">
                            <label className="col-lg-12  col-form-label">
                              {t("Total Cost")}{" "}
                              <Tooltip content={t("TotalCost_Tooltip")}>
                                <i class="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-lg-12">
                              <input
                                value={Helper.Amount(total_cost)}
                                onChange={(e) => setTotal_cost(e.target.value)}
                                type="text"
                                name="total_cost"
                                id="total_cost"
                                className="form-control"
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-4">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label">
                              {t("Down Payment")}{" "}
                              <Tooltip content={t("DownPayment_Tooltip")}>
                                <i class="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-lg-6">
                              <CurrencyInput
                                id="input-example"
                                name="input-name"
                                allowDecimals="false"
                                value={down_payment}
                                onValueChange={(value) =>
                                  setDown_payment(value)
                                }
                                className="form-control"
                                disableAbbreviations
                              />
                            </div>
                            <div className="col-lg-6">
                              <select
                                value={down_payment_payto}
                                onChange={(e) =>
                                  setDown_payment_payto(e.target.value)
                                }
                                id="down_payment_payto"
                                className="form-control"
                              >
                                <option value="">{t("Select")}</option>
                                <option value="Borrower">
                                  {t("Borrower")}
                                </option>
                                <option value="Dealer">{t("Dealer")}</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      {extrafiledcontractasset.length === 0 ? (
                        ""
                      ) : (
                        <h4 className="tc mt-4">
                          {t("Additional Information")} :
                        </h4>
                      )}
                      <div className="form-group row">
                        {extrafiledcontractasset.map((key, index) => (
                          <div
                            className={
                              key.enable === "True" ? "col-sm-6" : null
                            }
                          >
                            <>
                              <label
                                style={{
                                  display:
                                    key.enable === "True" ? true : "none",
                                }}
                                className="col-form-label"
                              >
                                {" "}
                                {key.label}{" "}
                                <Tooltip content={key.label}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <input
                                style={{
                                  display:
                                    key.enable === "True" ? true : "none",
                                }}
                                id={"attribute_" + index}
                                value={
                                  attribute[index]["attribute"]
                                    ? attribute[index]["attribute"]
                                    : ""
                                }
                                className="form-control mb-1"
                                name="attribute"
                                type={key.datatype}
                                placeholder={key.label}
                                onChange={(e) => onChangeextrafileds(e, index)}
                              />
                            </>
                          </div>
                        ))}
                      </div>
                      <div className="text-left py-3">
                        <input type="hidden" id="assetId" />
                        <button
                          type="button"
                          className="asset-cancel btn btn-secondary btn-md"
                          onClick={handleCancel}
                        >
                          {t("Cancel")}
                        </button>
                        &nbsp;
                        <button
                          type="button"
                          className="btn-assets border-0 btn btn-primary btn-gradient-primary btn-md"
                          onClick={handleSave}
                        >
                          {t("Save and continue editing ")}
                        </button>
                        &nbsp;
                        <button
                          type="submit"
                          disabled={disablebutton}
                          className="btn-assets border-0 btn btn-primary btn-gradient-primary btn-md"
                        >
                          {loading === false ? t("Update") : <ButtonLoading />}
                        </button>
                        &nbsp;
                      </div>
                    </>
                  }
                  <CheckButton style={{ display: "none" }} ref={checkBtn} />
                </Form>
              ) : (
                <ContentLoader
                  viewBox="0 0 1000 550"
                  backgroundColor="rgba(0,0,0,0.06)"
                  foregroundColor="rgba(0,0,0,0.12)"
                >
                  <rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
                  <circle cx="879" cy="123" r="11" />
                  <circle cx="914" cy="123" r="11" />
                  <rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
                  <rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
                  <rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
                  <rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
                  <circle cx="880" cy="184" r="11" />
                  <circle cx="915" cy="184" r="11" />
                  <rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
                  <rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
                  <rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
                  <rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
                  <circle cx="881" cy="242" r="11" />
                  <circle cx="916" cy="242" r="11" />
                  <rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
                  <rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
                  <rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
                  <rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
                  <circle cx="882" cy="303" r="11" />
                  <circle cx="917" cy="303" r="11" />
                  <rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
                  <rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
                  <rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
                  <rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
                  <circle cx="881" cy="363" r="11" />
                  <circle cx="916" cy="363" r="11" />
                  <rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
                  <rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
                  <rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
                  <rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
                  <circle cx="882" cy="424" r="11" />
                  <circle cx="917" cy="424" r="11" />
                  <rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
                  <rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
                  <rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
                  <rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
                  <rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
                  <rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
                  <circle cx="882" cy="484" r="11" />
                  <circle cx="917" cy="484" r="11" />
                  <rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
                  <rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
                  <rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
                  <rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
                  <rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
                  <rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
                  <rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
                  <rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
                  <rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
                  <rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
                </ContentLoader>
              )}
            </div>
          </div>
        </div>
      ) : (
        <AssetList
          id={contractId}
          contracttype={contract_term}
          party_id={party_id}
        ></AssetList>
      )}
    </>
  );
}

export default EditAssets;
